"use strict";
"use client";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/providers/FeatureProvider.tsx
function FeatureProvider({
  children,
  appId,
  publicKey,
  apiHost,
  cacheTimeout = 5 * 60 * 1e3,
  userId
}) {
  const [features, setFeatures] = (0, import_react.useState)([]);
  const [userPlan, setUserPlan] = (0, import_react.useState)(null);
  const [subscription, setSubscription] = (0, import_react.useState)(null);
  const [loading, setLoading] = (0, import_react.useState)(true);
  const [error, setError] = (0, import_react.useState)(null);
  const loadFeatures = (0, import_react.useCallback)(async () => {
    let resolvedUserId = null;
    if (typeof userId === "function") {
      resolvedUserId = await userId();
    } else {
      resolvedUserId = userId || null;
    }
    if (!resolvedUserId) {
      setFeatures([]);
      setUserPlan(null);
      setSubscription(null);
      setLoading(false);
      return;
    }
    try {
      setError(null);
      const response = await fetch(`${apiHost}/api/features/check`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${publicKey}`,
          "X-App-Id": appId
        },
        body: JSON.stringify({
          userId: resolvedUserId,
          appId
        })
      });
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      const data = await response.json();
      if (data.success) {
        const featuresArray = Array.isArray(data.features) ? data.features : [];
        setFeatures(featuresArray);
        setUserPlan(data.plan);
        setSubscription(data.subscription);
        localStorage.setItem("usecelo_features_cache", JSON.stringify({
          features: featuresArray,
          plan: data.plan,
          subscription: data.subscription,
          userId: resolvedUserId,
          timestamp: Date.now()
        }));
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Failed to load features";
      setError(errorMessage);
      console.error("UseCelo: Failed to load features:", err);
      try {
        const cached = localStorage.getItem("usecelo_features_cache");
        if (cached) {
          const { features: cachedFeatures, plan, subscription: cachedSub, userId: userId2, timestamp } = JSON.parse(cached);
          if (userId2 === resolvedUserId && Date.now() - timestamp < cacheTimeout) {
            setFeatures(Array.isArray(cachedFeatures) ? cachedFeatures : []);
            setUserPlan(plan);
            setSubscription(cachedSub);
            console.info("UseCelo: Using cached features");
          }
        }
      } catch (cacheError) {
        console.error("UseCelo: Failed to load cached features:", cacheError);
      }
    } finally {
      setLoading(false);
    }
  }, [appId, publicKey, apiHost, userId, cacheTimeout]);
  const checkAccess = (0, import_react.useCallback)((featureTag) => {
    return features.some((f) => f.tag === featureTag && f.hasAccess);
  }, [features]);
  const getFeature = (0, import_react.useCallback)((featureTag) => {
    return features.find((f) => f.tag === featureTag);
  }, [features]);
  const hasFeature = (0, import_react.useCallback)((featureTag) => {
    return checkAccess(featureTag);
  }, [checkAccess]);
  (0, import_react.useEffect)(() => {
    loadFeatures();
  }, [loadFeatures]);
  const contextValue = {
    features,
    userPlan,
    subscription,
    loading,
    error,
    checkAccess,
    getFeature,
    hasFeature,
    refreshFeatures: loadFeatures
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(FeatureContext.Provider, { value: contextValue, children });
}
function useFeatures() {
  const context = (0, import_react.useContext)(FeatureContext);
  if (!context) {
    throw new Error("useFeatures must be used within FeatureProvider");
  }
  return context;
}
var import_react, import_jsx_runtime, FeatureContext;
var init_FeatureProvider = __esm({
  "src/providers/FeatureProvider.tsx"() {
    "use strict";
    import_react = require("react");
    import_jsx_runtime = require("react/jsx-runtime");
    FeatureContext = (0, import_react.createContext)(null);
  }
});

// src/types/feature.ts
var init_feature = __esm({
  "src/types/feature.ts"() {
    "use strict";
  }
});

// src/types/index.ts
var ApiError, AuthError, NetworkError;
var init_types = __esm({
  "src/types/index.ts"() {
    "use strict";
    init_feature();
    ApiError = class extends Error {
      constructor(message, code, status) {
        super(message);
        this.code = code;
        this.status = status;
        this.name = "ApiError";
      }
    };
    AuthError = class extends Error {
      constructor(message, code) {
        super(message);
        this.code = code;
        this.name = "AuthError";
      }
    };
    NetworkError = class extends Error {
      constructor(message, originalError) {
        super(message);
        this.originalError = originalError;
        this.name = "NetworkError";
      }
    };
  }
});

// src/api/payment-client.ts
var PaymentGatewayClient;
var init_payment_client = __esm({
  "src/api/payment-client.ts"() {
    "use strict";
    init_types();
    PaymentGatewayClient = class {
      // 5 minutes
      constructor(config) {
        this.authToken = null;
        this.gatewayInfoCache = null;
        this.CACHE_DURATION = 5 * 60 * 1e3;
        this.config = {
          apiHost: "https://usecelo.com",
          ...config
        };
      }
      /**
       * Set authentication token (consistent with api-client)
       */
      setAuthToken(token) {
        this.authToken = token;
      }
      /**
       * Clear cached gateway info
       */
      clearCache() {
        this.gatewayInfoCache = null;
      }
      /**
       * Generic request method (follows api-client pattern)
       */
      async request(endpoint, options = {}) {
        const url = `${this.config.apiHost}${endpoint}`;
        const headers = {
          "Content-Type": "application/json",
          "x-api-key": this.config.publicKey,
          ...options.headers || {}
        };
        if (this.authToken) {
          headers.Authorization = `Bearer ${this.authToken}`;
        }
        try {
          const response = await fetch(url, {
            ...options,
            headers
          });
          if (!response.ok) {
            if (response.status === 401) {
              this.authToken = null;
              throw new AuthError("Invalid API key or authentication token");
            }
            const errorData = await response.json().catch(() => ({}));
            throw new ApiError(
              errorData.message || `HTTP ${response.status}`,
              response.status.toString(),
              response.status
            );
          }
          const data = await response.json();
          if (!data.success) {
            throw new ApiError(data.error || "API request failed", "400", 400);
          }
          return data.data;
        } catch (error) {
          if (error instanceof ApiError || error instanceof AuthError) {
            throw error;
          }
          throw new NetworkError(`Request failed: ${error instanceof Error ? error.message : "Unknown error"}`);
        }
      }
      /**
       * Get configured gateway information for the app (with caching)
       */
      async getGatewayInfo() {
        if (this.gatewayInfoCache && Date.now() - this.gatewayInfoCache.timestamp < this.CACHE_DURATION) {
          return this.gatewayInfoCache.info;
        }
        const info = await this.request(
          `/api/public/gateway/${this.config.appId}/info`
        );
        this.gatewayInfoCache = {
          info,
          timestamp: Date.now()
        };
        return info;
      }
      /**
       * Create a checkout session for any configured gateway
       * This works with both OAuth and Adapter integrations
       */
      async createCheckout(options) {
        const userId = options.userId || this.config.userId;
        if (!userId) {
          throw new AuthError("User ID is required for checkout");
        }
        if (!options.planId) {
          throw new ApiError("Plan ID is required for checkout", "400", 400);
        }
        const response = await this.request(
          "/api/public/checkout/session",
          {
            method: "POST",
            body: JSON.stringify({
              appId: this.config.appId,
              userId,
              ...options
            })
          }
        );
        console.log("\u{1F50D} PaymentClient: Response from API:", response);
        if (!response || !response.url) {
          console.log("\u274C PaymentClient: No response or URL found");
          throw new ApiError("Failed to create checkout session", "400", 400);
        }
        return response;
      }
      /**
       * Create a customer portal session (if supported by gateway)
       */
      async createPortalSession(options = {}) {
        const userId = options.userId || this.config.userId;
        if (!userId) {
          throw new AuthError("User ID is required for portal session");
        }
        const gatewayInfo = await this.getGatewayInfo();
        if (!gatewayInfo.capabilities.portal) {
          throw new ApiError("Customer portal is not supported by the configured payment gateway", "400", 400);
        }
        const response = await this.request(
          "/api/public/portal/session",
          {
            method: "POST",
            body: JSON.stringify({
              appId: this.config.appId,
              userId,
              ...options
            })
          }
        );
        if (!response.data) {
          throw new ApiError(response.error || "Failed to create portal session", "400", 400);
        }
        return response.data;
      }
      /**
       * Get payment methods for a user
       */
      async getPaymentMethods(userId) {
        const userParam = userId || this.config.userId;
        if (!userParam) {
          throw new AuthError("User ID is required to get payment methods");
        }
        const response = await this.request(
          `/api/public/payment-methods?userId=${encodeURIComponent(userParam)}&appId=${encodeURIComponent(this.config.appId)}`
        );
        return response.data || [];
      }
      /**
       * Update default payment method
       */
      async updateDefaultPaymentMethod(paymentMethodId, userId) {
        const userParam = userId || this.config.userId;
        if (!userParam) {
          throw new AuthError("User ID is required for payment method update");
        }
        return this.request(
          "/api/public/payment-methods/default",
          {
            method: "POST",
            body: JSON.stringify({
              appId: this.config.appId,
              userId: userParam,
              paymentMethodId
            })
          }
        );
      }
      /**
       * Add a new payment method (returns URL for payment method addition flow)
       */
      async addPaymentMethod(options = {}) {
        const userId = options.userId || this.config.userId;
        if (!userId) {
          throw new AuthError("User ID is required for adding payment method");
        }
        return this.request(
          "/api/public/payment-methods/add",
          {
            method: "POST",
            body: JSON.stringify({
              appId: this.config.appId,
              userId,
              ...options
            })
          }
        );
      }
      /**
       * Remove a payment method
       */
      async removePaymentMethod(paymentMethodId, userId) {
        const userParam = userId || this.config.userId;
        if (!userParam) {
          throw new AuthError("User ID is required for removing payment method");
        }
        return this.request(
          `/api/public/payment-methods/${paymentMethodId}`,
          {
            method: "DELETE",
            body: JSON.stringify({
              appId: this.config.appId,
              userId: userParam
            })
          }
        );
      }
      /**
       * Get current subscription details
       */
      async getSubscription(userId) {
        const userParam = userId || this.config.userId;
        if (!userParam) {
          throw new AuthError("User ID is required to get subscription");
        }
        const response = await this.request(
          `/api/public/subscriptions/current?externalId=${encodeURIComponent(userParam)}&appId=${encodeURIComponent(this.config.appId)}`
        );
        return response || null;
      }
      /**
       * Update subscription plan
       */
      async updateSubscription(options) {
        const userId = options.userId || this.config.userId;
        if (!userId) {
          throw new AuthError("User ID is required for subscription update");
        }
        const response = await this.request(
          "/api/public/subscriptions/update",
          {
            method: "POST",
            body: JSON.stringify({
              appId: this.config.appId,
              userId,
              ...options
            })
          }
        );
        if (!response.data) {
          throw new ApiError(response.error || "Failed to update subscription", "400", 400);
        }
        return response.data;
      }
      /**
       * Cancel subscription
       */
      async cancelSubscription(options = {}) {
        const userId = options.userId || this.config.userId;
        if (!userId) {
          throw new AuthError("User ID is required for subscription cancellation");
        }
        return this.request(
          "/api/public/subscriptions/cancel",
          {
            method: "POST",
            body: JSON.stringify({
              externalId: userId,
              immediate: options.immediate,
              reason: options.reason,
              feedback: options.feedback
            })
          }
        );
      }
      /**
       * Pause subscription (if supported)
       */
      async pauseSubscription(options = {}) {
        const userId = options.userId || this.config.userId;
        if (!userId) {
          throw new AuthError("User ID is required for subscription pause");
        }
        const gatewayInfo = await this.getGatewayInfo();
        if (!gatewayInfo.capabilities.subscriptionPause) {
          throw new ApiError("Subscription pause is not supported by the configured payment gateway", "400", 400);
        }
        return this.request(
          "/api/public/subscriptions/pause",
          {
            method: "POST",
            body: JSON.stringify({
              appId: this.config.appId,
              userId,
              until: options.until?.toISOString(),
              behavior: options.behavior,
              resumeType: options.resumeType
            })
          }
        );
      }
      /**
       * Resume subscription
       */
      async resumeSubscription(userId) {
        const userParam = userId || this.config.userId;
        if (!userParam) {
          throw new AuthError("User ID is required for subscription resume");
        }
        const response = await this.request(
          "/api/public/subscriptions/resume",
          {
            method: "POST",
            body: JSON.stringify({
              appId: this.config.appId,
              userId: userParam
            })
          }
        );
        if (!response.data) {
          throw new ApiError(response.error || "Failed to resume subscription", "400", 400);
        }
        return response.data;
      }
      /**
       * Get invoices for a user
       */
      async getInvoices(userId, limit = 10, cursor) {
        const userParam = userId || this.config.userId;
        if (!userParam) {
          throw new AuthError("User ID is required to get invoices");
        }
        const params = new URLSearchParams({
          userId: userParam,
          appId: this.config.appId,
          limit: limit.toString()
        });
        if (cursor) {
          params.append("cursor", cursor);
        }
        return this.request(
          `/api/public/invoices?${params.toString()}`
        );
      }
      /**
       * Download invoice
       */
      async downloadInvoice(invoiceId, userId) {
        const userParam = userId || this.config.userId;
        if (!userParam) {
          throw new AuthError("User ID is required to download invoice");
        }
        return this.request(
          `/api/public/invoices/${invoiceId}/download?userId=${encodeURIComponent(userParam)}&appId=${encodeURIComponent(this.config.appId)}`
        );
      }
      /**
       * Request a refund
       */
      async requestRefund(request) {
        return this.request(
          "/api/public/refunds",
          {
            method: "POST",
            body: JSON.stringify({
              appId: this.config.appId,
              ...request
            })
          }
        );
      }
      /**
       * Check if the app has a payment gateway configured
       */
      async isPaymentConfigured() {
        try {
          const info = await this.getGatewayInfo();
          return info.isConfigured;
        } catch {
          return false;
        }
      }
      /**
       * Get checkout URL directly (convenience method)
       */
      async getCheckoutUrl(planId, options = {}) {
        const session = await this.createCheckout({
          planId,
          ...options
        });
        return session.url;
      }
      /**
       * Get portal URL directly (convenience method)
       */
      async getPortalUrl(options) {
        const session = await this.createPortalSession(options);
        return session.url;
      }
      /**
       * Check gateway capabilities
       */
      async checkCapability(capability) {
        const info = await this.getGatewayInfo();
        return info.capabilities[capability] || false;
      }
    };
  }
});

// src/providers/PaymentProvider.tsx
function PaymentProvider({
  children,
  appId,
  publicKey,
  apiHost,
  enabled,
  autoLoadGatewayInfo = true,
  onGatewayInfoLoaded,
  onPaymentError,
  userId
}) {
  const [gatewayInfo, setGatewayInfo] = (0, import_react2.useState)(null);
  const [paymentLoading, setPaymentLoading] = (0, import_react2.useState)(false);
  const resolveUserId = (0, import_react2.useCallback)(async () => {
    if (typeof userId === "function") {
      return await userId();
    }
    return userId || null;
  }, [userId]);
  const paymentClient = (0, import_react2.useMemo)(() => {
    if (!enabled) return null;
    return new PaymentGatewayClient({
      publicKey,
      appId,
      apiHost: apiHost || "https://usecelo.com"
      // Note: userId will be resolved dynamically in individual methods
    });
  }, [enabled, publicKey, appId, apiHost]);
  const loadGatewayInfo = (0, import_react2.useCallback)(async () => {
    if (!enabled || !paymentClient) {
      return;
    }
    setPaymentLoading(true);
    try {
      const info = await paymentClient.getGatewayInfo();
      setGatewayInfo(info);
      onGatewayInfoLoaded?.(info);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Failed to load gateway info";
      onPaymentError?.(errorMessage);
      console.error("UseCelo: Failed to load gateway info:", err);
    } finally {
      setPaymentLoading(false);
    }
  }, [enabled, paymentClient, onGatewayInfoLoaded, onPaymentError]);
  const createCheckout = (0, import_react2.useCallback)(async (options) => {
    if (!paymentClient) {
      throw new Error("Payment not enabled");
    }
    const result = await paymentClient.createCheckout(options);
    return result;
  }, [paymentClient]);
  const getCheckoutUrl = (0, import_react2.useCallback)(async (planId, options) => {
    const session = await createCheckout({ planId, ...options });
    return session.url;
  }, [createCheckout]);
  const createPortalSession = (0, import_react2.useCallback)(async (options) => {
    if (!paymentClient) throw new Error("Payment not enabled");
    return await paymentClient.createPortalSession(options || {});
  }, [paymentClient]);
  const getSubscription = (0, import_react2.useCallback)(async (userIdParam) => {
    if (!paymentClient) throw new Error("Payment not enabled");
    const resolvedUserId = userIdParam || await resolveUserId();
    return await paymentClient.getSubscription(resolvedUserId || "");
  }, [paymentClient, resolveUserId]);
  const cancelSubscription = (0, import_react2.useCallback)(async (options) => {
    if (!paymentClient) throw new Error("Payment not enabled");
    await paymentClient.cancelSubscription(options || {});
  }, [paymentClient]);
  const pauseSubscription = (0, import_react2.useCallback)(async (options) => {
    if (!paymentClient) throw new Error("Payment not enabled");
    await paymentClient.pauseSubscription(options || {});
  }, [paymentClient]);
  const resumeSubscription = (0, import_react2.useCallback)(async (userIdParam) => {
    if (!paymentClient) throw new Error("Payment not enabled");
    const resolvedUserId = userIdParam || await resolveUserId();
    await paymentClient.resumeSubscription(resolvedUserId || "");
  }, [paymentClient, resolveUserId]);
  const getPaymentMethods = (0, import_react2.useCallback)(async (userIdParam) => {
    if (!paymentClient) throw new Error("Payment not enabled");
    const resolvedUserId = userIdParam || await resolveUserId();
    return await paymentClient.getPaymentMethods(resolvedUserId || "");
  }, [paymentClient, resolveUserId]);
  (0, import_react2.useEffect)(() => {
    if (enabled && autoLoadGatewayInfo) {
      loadGatewayInfo();
    }
  }, [enabled, autoLoadGatewayInfo, loadGatewayInfo]);
  if (!enabled) {
    return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_jsx_runtime2.Fragment, { children });
  }
  const isPaymentConfigured = gatewayInfo?.isConfigured || false;
  const contextValue = {
    gatewayInfo,
    paymentLoading,
    isPaymentConfigured,
    paymentClient,
    createCheckout,
    getCheckoutUrl,
    createPortalSession,
    getSubscription,
    cancelSubscription,
    pauseSubscription,
    resumeSubscription,
    getPaymentMethods,
    refreshGatewayInfo: loadGatewayInfo
  };
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(PaymentContext.Provider, { value: contextValue, children });
}
function usePayment() {
  const context = (0, import_react2.useContext)(PaymentContext);
  if (!context) {
    throw new Error("usePayment must be used within PaymentProvider");
  }
  return context;
}
var import_react2, import_jsx_runtime2, PaymentContext;
var init_PaymentProvider = __esm({
  "src/providers/PaymentProvider.tsx"() {
    "use strict";
    import_react2 = require("react");
    init_payment_client();
    import_jsx_runtime2 = require("react/jsx-runtime");
    PaymentContext = (0, import_react2.createContext)(null);
  }
});

// src/providers/UsageTrackingProvider.tsx
function UsageTrackingProvider({
  children,
  appId,
  publicKey,
  apiHost,
  userId
}) {
  const resolveUserId = (0, import_react3.useCallback)(async () => {
    if (typeof userId === "function") {
      return await userId();
    }
    return userId || null;
  }, [userId]);
  const usageQueue = (0, import_react3.useRef)([]);
  const flushTimeoutRef = (0, import_react3.useRef)(null);
  const flushUsageQueue = (0, import_react3.useCallback)(async () => {
    const resolvedUserId = await resolveUserId();
    if (usageQueue.current.length === 0 || !resolvedUserId) return;
    const currentQueue = [...usageQueue.current];
    usageQueue.current = [];
    try {
      const response = await fetch(`${apiHost}/api/usage/track`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${publicKey}`,
          "X-App-Id": appId
        },
        body: JSON.stringify({
          userId: resolvedUserId,
          usage: currentQueue
        })
      });
      if (!response.ok) {
        console.error("UseCelo: Failed to track usage:", response.statusText);
        usageQueue.current.unshift(...currentQueue);
      }
    } catch (error) {
      console.error("UseCelo: Usage tracking error:", error);
      usageQueue.current.unshift(...currentQueue);
    }
  }, [appId, publicKey, apiHost, resolveUserId]);
  const scheduleFlush = (0, import_react3.useCallback)(() => {
    if (flushTimeoutRef.current) {
      clearTimeout(flushTimeoutRef.current);
    }
    flushTimeoutRef.current = setTimeout(flushUsageQueue, 2e3);
  }, [flushUsageQueue]);
  const trackUsage = (0, import_react3.useCallback)(async (usage) => {
    const resolvedUserId = await resolveUserId();
    if (!resolvedUserId) {
      console.warn("UseCelo: Cannot track usage - no userId provided");
      return;
    }
    const normalizedUsage = usage.map((u) => ({
      featureTag: u.featureTag,
      quantity: u.quantity || 1,
      metadata: u.metadata
    }));
    usageQueue.current.push(...normalizedUsage);
    scheduleFlush();
  }, [resolveUserId, scheduleFlush]);
  const trackSingleUsage = (0, import_react3.useCallback)(async (featureTag, quantity = 1, metadata) => {
    await trackUsage([{ featureTag, quantity, metadata }]);
  }, [trackUsage]);
  const contextValue = {
    trackUsage,
    trackSingleUsage
  };
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(UsageContext.Provider, { value: contextValue, children });
}
function useUsageTracking() {
  const context = (0, import_react3.useContext)(UsageContext);
  if (!context) {
    throw new Error("useUsageTracking must be used within UsageTrackingProvider");
  }
  return context;
}
var import_react3, import_jsx_runtime3, UsageContext;
var init_UsageTrackingProvider = __esm({
  "src/providers/UsageTrackingProvider.tsx"() {
    "use strict";
    import_react3 = require("react");
    import_jsx_runtime3 = require("react/jsx-runtime");
    UsageContext = (0, import_react3.createContext)(null);
  }
});

// src/providers/FeatureGatingProvider.tsx
function FeatureGatingProvider({
  children,
  fallbackBehavior = "hide",
  onFeatureBlock,
  onUpgradeClick
}) {
  const { features, loading } = useFeatures();
  const observerRef = (0, import_react4.useRef)(null);
  const processedElements = (0, import_react4.useRef)(/* @__PURE__ */ new WeakSet());
  const applyFallback = (0, import_react4.useCallback)((element, strategy, featureName) => {
    const htmlElement = element;
    if (!htmlElement.dataset.useCeloOriginalDisplay) {
      htmlElement.dataset.useCeloOriginalDisplay = window.getComputedStyle(htmlElement).display;
    }
    switch (strategy || fallbackBehavior) {
      case "hide":
        htmlElement.style.display = "none";
        break;
      case "disable":
        htmlElement.style.opacity = "0.5";
        htmlElement.style.pointerEvents = "none";
        htmlElement.setAttribute("aria-disabled", "true");
        break;
      case "blur":
        htmlElement.style.filter = "blur(4px)";
        htmlElement.style.position = "relative";
        const overlay = document.createElement("div");
        overlay.className = "usecelo-blur-overlay";
        overlay.style.cssText = `
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(0,0,0,0.1);
          backdrop-filter: blur(2px);
          z-index: 10;
          cursor: pointer;
        `;
        overlay.innerHTML = `
          <div style="background: white; padding: 20px; border-radius: 8px; text-align: center; box-shadow: 0 4px 6px rgba(0,0,0,0.1);">
            <p style="margin: 0 0 10px 0; color: #333;">This feature requires an upgrade</p>
            <button style="background: #10b981; color: white; border: none; padding: 8px 16px; border-radius: 4px; cursor: pointer;">
              Upgrade Plan
            </button>
          </div>
        `;
        overlay.addEventListener("click", () => {
          onUpgradeClick?.(featureName);
        });
        htmlElement.appendChild(overlay);
        break;
      case "upgrade":
        if (!htmlElement.dataset.useCeloOriginalContent) {
          htmlElement.dataset.useCeloOriginalContent = htmlElement.innerHTML;
        }
        htmlElement.innerHTML = `
          <div class="usecelo-upgrade-prompt" style="padding: 20px; background: #f3f4f6; border-radius: 8px; text-align: center;">
            <p style="margin-bottom: 10px; color: #333;">
              ${featureName.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())} requires an upgrade
            </p>
            <button onclick="window.useCelo?.showUpgrade?.('${featureName}')" style="background: #10b981; color: white; padding: 8px 16px; border-radius: 4px; border: none; cursor: pointer;">
              Upgrade Plan
            </button>
          </div>
        `;
        break;
      default:
        htmlElement.style.display = "none";
    }
    onFeatureBlock?.(featureName);
  }, [fallbackBehavior, onFeatureBlock, onUpgradeClick]);
  const restoreElement = (0, import_react4.useCallback)((element) => {
    const htmlElement = element;
    if (htmlElement.dataset.useCeloOriginalDisplay) {
      htmlElement.style.display = htmlElement.dataset.useCeloOriginalDisplay;
      delete htmlElement.dataset.useCeloOriginalDisplay;
    }
    if (htmlElement.dataset.useCeloOriginalContent) {
      htmlElement.innerHTML = htmlElement.dataset.useCeloOriginalContent;
      delete htmlElement.dataset.useCeloOriginalContent;
    }
    const overlay = htmlElement.querySelector(".usecelo-blur-overlay");
    if (overlay) overlay.remove();
    htmlElement.style.opacity = "";
    htmlElement.style.pointerEvents = "";
    htmlElement.style.filter = "";
    htmlElement.removeAttribute("aria-disabled");
  }, []);
  const processElement = (0, import_react4.useCallback)((element) => {
    if (processedElements.current.has(element)) return;
    const featureName = element.getAttribute("data-feature");
    if (!featureName) return;
    const featureAccess = features.find((f) => f.tag === featureName);
    const fallbackStrategy = element.getAttribute("data-fallback");
    if (!featureAccess?.hasAccess) {
      applyFallback(element, fallbackStrategy || fallbackBehavior, featureName);
    } else {
      restoreElement(element);
    }
    processedElements.current.add(element);
  }, [features, fallbackBehavior, applyFallback, restoreElement]);
  (0, import_react4.useEffect)(() => {
    if (loading) return;
    const processAllElements = () => {
      document.querySelectorAll("[data-feature]").forEach(processElement);
    };
    processAllElements();
    observerRef.current = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            const element = node;
            if (element.hasAttribute("data-feature")) {
              processElement(element);
            }
            element.querySelectorAll?.("[data-feature]").forEach(processElement);
          }
        });
        if (mutation.type === "attributes" && mutation.target.nodeType === 1) {
          const element = mutation.target;
          if (element.hasAttribute("data-feature")) {
            processedElements.current.delete(element);
            processElement(element);
          }
        }
      });
    });
    observerRef.current.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-feature", "data-fallback"]
    });
    return () => {
      observerRef.current?.disconnect();
    };
  }, [loading, processElement]);
  (0, import_react4.useEffect)(() => {
    window.useCelo = {
      ...window.useCelo || {},
      showUpgrade: (featureName) => {
        onUpgradeClick?.(featureName);
      }
    };
  }, [onUpgradeClick]);
  const contextValue = {};
  return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(FeatureGatingContext.Provider, { value: contextValue, children });
}
var import_react4, import_jsx_runtime4, FeatureGatingContext;
var init_FeatureGatingProvider = __esm({
  "src/providers/FeatureGatingProvider.tsx"() {
    "use strict";
    import_react4 = require("react");
    init_FeatureProvider();
    import_jsx_runtime4 = require("react/jsx-runtime");
    FeatureGatingContext = (0, import_react4.createContext)(null);
  }
});

// src/providers/UseCeloClientProvider.tsx
var UseCeloClientProvider_exports = {};
__export(UseCeloClientProvider_exports, {
  UseCeloClientProvider: () => UseCeloClientProvider
});
function UseCeloClientProvider({
  userId,
  ...props
}) {
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
    FeatureProvider,
    {
      appId: props.appId,
      publicKey: props.publicKey,
      apiHost: props.apiHost || "https://usecelo.com",
      cacheTimeout: props.cacheTimeout,
      userId,
      children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
        UsageTrackingProvider,
        {
          appId: props.appId,
          publicKey: props.publicKey,
          apiHost: props.apiHost || "https://usecelo.com",
          userId,
          children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
            PaymentProvider,
            {
              appId: props.appId,
              publicKey: props.publicKey,
              apiHost: props.apiHost || "https://usecelo.com",
              enabled: props.enablePayments || false,
              autoLoadGatewayInfo: props.autoLoadGatewayInfo,
              onGatewayInfoLoaded: props.onGatewayInfoLoaded,
              onPaymentError: props.onPaymentError,
              userId,
              children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(UseCeloClientInner, { ...props, userId })
            }
          )
        }
      )
    }
  );
}
function UseCeloClientInner({
  children,
  appId,
  publicKey,
  apiHost = "https://usecelo.com",
  fallbackBehavior = "hide",
  onFeatureBlock,
  onUpgradeClick,
  enablePayments = false,
  userId
}) {
  const features = useFeatures();
  const payment = enablePayments ? usePayment() : null;
  const usageTracking = useUsageTracking();
  const contextValue = {
    // Feature state and methods
    features: features.features,
    loading: features.loading || (payment?.paymentLoading ?? false),
    error: features.error,
    userPlan: features.userPlan,
    subscription: features.subscription,
    checkAccess: features.checkAccess,
    getFeature: features.getFeature,
    hasFeature: features.hasFeature,
    refreshFeatures: features.refreshFeatures,
    // Auth - simplified approach
    userId,
    // Usage tracking
    trackUsage: usageTracking.trackUsage,
    trackSingleUsage: usageTracking.trackSingleUsage,
    // Configuration
    appId,
    publicKey,
    apiHost,
    // Payment integration (when enabled)
    ...enablePayments && payment && {
      paymentClient: payment.paymentClient || void 0,
      gatewayInfo: payment.gatewayInfo,
      isPaymentConfigured: payment.isPaymentConfigured,
      createCheckout: payment.createCheckout,
      getCheckoutUrl: payment.getCheckoutUrl,
      createPortalSession: payment.createPortalSession,
      getSubscription: payment.getSubscription,
      cancelSubscription: payment.cancelSubscription,
      pauseSubscription: payment.pauseSubscription,
      resumeSubscription: payment.resumeSubscription,
      getPaymentMethods: payment.getPaymentMethods,
      refreshGatewayInfo: payment.refreshGatewayInfo
    }
  };
  (0, import_react5.useEffect)(() => {
    const { checkAccess, trackSingleUsage } = contextValue;
    window.useCelo = {
      ...window.useCelo || {},
      checkAccess,
      trackUsage: trackSingleUsage
    };
  }, [contextValue]);
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(UseCeloContext.Provider, { value: contextValue, children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
    FeatureGatingProvider,
    {
      fallbackBehavior,
      onFeatureBlock,
      onUpgradeClick,
      children
    }
  ) });
}
var import_react5, import_jsx_runtime5;
var init_UseCeloClientProvider = __esm({
  "src/providers/UseCeloClientProvider.tsx"() {
    "use strict";
    "use client";
    import_react5 = require("react");
    init_FeatureProvider();
    init_PaymentProvider();
    init_UsageTrackingProvider();
    init_FeatureGatingProvider();
    init_UseCeloProvider();
    import_jsx_runtime5 = require("react/jsx-runtime");
  }
});

// src/providers/UseCeloProvider.tsx
function UseCeloServerProvider({
  children,
  appId,
  publicKey,
  apiHost = "https://usecelo.com",
  enablePayments = false
}) {
  const contextValue = {
    // Core state (safe defaults)
    features: [],
    loading: false,
    // Don't show loading on server to prevent layout shift
    error: null,
    userPlan: null,
    subscription: null,
    // Auth (server-safe default)
    userId: null,
    // Feature methods (conservative server defaults)
    checkAccess: () => false,
    // Conservative: deny access on server
    getFeature: () => void 0,
    hasFeature: () => false,
    // Usage tracking (no-ops)
    trackUsage: noopAsync,
    trackSingleUsage: noopAsync,
    // Data management (no-ops)
    refreshFeatures: noopAsync,
    // Configuration
    appId,
    publicKey,
    apiHost,
    // Payment integration (undefined - not available on server)
    ...enablePayments && {
      paymentClient: void 0,
      gatewayInfo: null,
      isPaymentConfigured: false,
      createCheckout: noopAsyncReturn,
      getCheckoutUrl: noopAsyncReturn,
      createPortalSession: noopAsyncReturn,
      getSubscription: noopAsyncReturn,
      cancelSubscription: noopAsync,
      pauseSubscription: noopAsync,
      resumeSubscription: noopAsync,
      getPaymentMethods: noopAsyncReturn,
      refreshGatewayInfo: noopAsync
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(UseCeloContext.Provider, { value: contextValue, children });
}
function UseCeloClientProvider2(props) {
  const [mounted, setMounted] = (0, import_react6.useState)(false);
  (0, import_react6.useEffect)(() => {
    setMounted(true);
  }, []);
  if (!mounted) {
    return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(UseCeloServerProvider, { ...props });
  }
  const { UseCeloClientProvider: ClientProvider } = (init_UseCeloClientProvider(), __toCommonJS(UseCeloClientProvider_exports));
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(ClientProvider, { ...props });
}
function UseCeloProvider({
  userId,
  mode = "auto",
  ...props
}) {
  if (mode === "ssr" || mode === "auto" && isServer) {
    return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(UseCeloServerProvider, { ...props, children: props.children });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(UseCeloClientProvider2, { userId, ...props });
}
function useUseCelo() {
  const context = (0, import_react6.useContext)(UseCeloContext);
  if (!context) {
    if (typeof window === "undefined") {
      return {
        // Core state (safe defaults)
        features: [],
        loading: false,
        error: null,
        userPlan: null,
        subscription: null,
        // Auth (server-safe default)
        userId: null,
        // Feature methods (conservative server defaults)
        checkAccess: () => false,
        getFeature: () => void 0,
        hasFeature: () => false,
        // Usage tracking (no-ops)
        trackUsage: async () => {
        },
        trackSingleUsage: async () => {
        },
        // Data management (no-ops)
        refreshFeatures: async () => {
        },
        // Configuration (defaults)
        appId: "",
        publicKey: "",
        apiHost: "https://usecelo.com",
        // Payment integration (undefined - not available on server)
        paymentClient: void 0,
        gatewayInfo: null,
        isPaymentConfigured: false,
        createCheckout: async () => ({ url: "", sessionId: "", gateway: "stripe" }),
        getCheckoutUrl: async () => "",
        createPortalSession: async () => ({ url: "" }),
        getSubscription: async () => null,
        cancelSubscription: async () => {
        },
        pauseSubscription: async () => {
        },
        resumeSubscription: async () => {
        },
        getPaymentMethods: async () => [],
        refreshGatewayInfo: async () => {
        }
      };
    }
    throw new Error("useUseCelo must be used within UseCeloProvider");
  }
  return context;
}
function useFeature(featureTag) {
  const { getFeature, hasFeature, loading } = useUseCelo();
  const feature = getFeature(featureTag);
  return {
    hasAccess: hasFeature(featureTag),
    feature,
    config: feature?.config,
    limits: feature?.limits,
    usage: feature?.usage,
    loading
  };
}
function Feature({
  name,
  children,
  fallback
}) {
  const { hasFeature } = useUseCelo();
  return hasFeature(name) ? /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_jsx_runtime6.Fragment, { children }) : /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_jsx_runtime6.Fragment, { children: fallback });
}
function useCheckout() {
  const context = useUseCelo();
  if (!context.createCheckout || !context.getCheckoutUrl) {
    throw new Error("Payments not enabled. Set enablePayments: true in UseCeloProvider");
  }
  return {
    createCheckout: context.createCheckout,
    getCheckoutUrl: context.getCheckoutUrl,
    initiateCheckout: async (planId, options) => {
      if (isServer) return;
      const url = await context.getCheckoutUrl(planId, options);
      window.location.href = url;
    },
    isReady: context.isPaymentConfigured || false,
    gateway: context.gatewayInfo?.gateway || null
  };
}
function useSubscriptionManagement() {
  const context = useUseCelo();
  if (!context.getSubscription) {
    throw new Error("Payments not enabled. Set enablePayments: true in UseCeloProvider");
  }
  const [subscriptionDetails, setSubscriptionDetails] = (0, import_react6.useState)(null);
  const [subLoading, setSubLoading] = (0, import_react6.useState)(false);
  const loadSubscription = async (userId) => {
    if (isServer) return null;
    setSubLoading(true);
    try {
      const sub = await context.getSubscription(userId);
      setSubscriptionDetails(sub);
      return sub;
    } finally {
      setSubLoading(false);
    }
  };
  return {
    subscription: subscriptionDetails,
    isLoading: subLoading,
    loadSubscription,
    cancelSubscription: context.cancelSubscription,
    pauseSubscription: context.pauseSubscription,
    resumeSubscription: context.resumeSubscription,
    getPaymentMethods: context.getPaymentMethods
  };
}
var import_react6, import_jsx_runtime6, UseCeloContext, noopAsync, noopAsyncReturn, isServer;
var init_UseCeloProvider = __esm({
  "src/providers/UseCeloProvider.tsx"() {
    "use strict";
    import_react6 = require("react");
    import_jsx_runtime6 = require("react/jsx-runtime");
    UseCeloContext = (0, import_react6.createContext)(null);
    noopAsync = async () => {
    };
    noopAsyncReturn = async () => null;
    isServer = typeof window === "undefined";
  }
});

// src/index.ts
var index_exports = {};
__export(index_exports, {
  CheckoutButton: () => CheckoutButton,
  CheckoutCancel: () => CheckoutCancel,
  CheckoutSuccess: () => CheckoutSuccess,
  Feature: () => Feature,
  FeatureGate: () => Feature2,
  MultiFeatures: () => MultiFeatures,
  MultiUsageDisplay: () => MultiUsageDisplay,
  PaymentGatewayClient: () => PaymentGatewayClient,
  PlanTier: () => PlanTier,
  PricingTable: () => PricingTable,
  SimplifiedSubscriptionManager: () => SimplifiedSubscriptionManager,
  SubscriptionGate: () => SubscriptionGate,
  SubscriptionManager: () => SimplifiedSubscriptionManager,
  TrialOnly: () => TrialOnly,
  UpgradePrompt: () => UpgradePrompt,
  UsageControl: () => UsageControl,
  UsageDisplay: () => UsageDisplay,
  UsageTracker: () => UsageTracker,
  UseCeloApiClient: () => UseCeloApiClient,
  UseCeloProvider: () => UseCeloProvider,
  UserIdProvider: () => UserIdProvider,
  VERSION: () => VERSION,
  useCheckout: () => useCheckout,
  useCheckoutButton: () => useCheckoutButton,
  useCheckoutCancel: () => useCheckoutCancel,
  useCheckoutFlow: () => useCheckoutFlow,
  useCheckoutSuccess: () => useCheckoutSuccess,
  useFeature: () => useFeature,
  usePricing: () => usePricing,
  usePricingFeature: () => useFeature2,
  usePricingSubscription: () => useSubscription,
  usePricingTableConfig: () => usePricingTableConfig,
  useSubscriptionManagement: () => useSubscriptionManagement,
  useUsage: () => useUsage,
  useUsageStats: () => useUsageStats,
  useUseCelo: () => useUseCelo,
  withFeatureGate: () => withFeatureGate
});
module.exports = __toCommonJS(index_exports);
init_UseCeloProvider();

// src/hooks/usePricing.ts
var import_react7 = require("react");
init_UseCeloProvider();
function usePricing() {
  const context = useUseCelo();
  const hasFeature = (0, import_react7.useCallback)((featureTag) => {
    return context.hasFeature(featureTag);
  }, [context]);
  const getFeature = (0, import_react7.useCallback)((featureTag) => {
    return context.getFeature(featureTag);
  }, [context]);
  const getUsage = (0, import_react7.useCallback)((featureTag) => {
    const feature = context.getFeature(featureTag);
    return typeof feature?.usage === "number" ? feature.usage : null;
  }, [context]);
  const isTrialing = (0, import_react7.useMemo)(() => {
    return context.subscription?.status === "trialing";
  }, [context.subscription]);
  const isSubscribed = (0, import_react7.useMemo)(() => {
    return context.subscription?.status === "active" || context.subscription?.status === "trialing";
  }, [context.subscription]);
  const upgradeUrl = (0, import_react7.useMemo)(() => {
    const baseUrl = context.apiHost?.replace("/api", "") || "https://usecelo.com";
    return `${baseUrl}/upgrade?appId=${context.appId}`;
  }, [context.apiHost, context.appId]);
  const billingUrl = (0, import_react7.useMemo)(() => {
    const baseUrl = context.apiHost?.replace("/api", "") || "https://usecelo.com";
    return `${baseUrl}/billing?appId=${context.appId}`;
  }, [context.apiHost, context.appId]);
  const trackUsageWithCheck = (0, import_react7.useCallback)(async (featureTag, amount = 1, options = {}) => {
    const { checkBeforeTrack = true, throwOnLimitExceeded = true } = options;
    try {
      if (checkBeforeTrack && !hasFeature(featureTag)) {
        const error = new Error(`Feature '${featureTag}' is not accessible`);
        if (throwOnLimitExceeded) throw error;
        return { success: false, reason: "no_access", error: error.message };
      }
      await context.trackSingleUsage(featureTag, amount);
      return { success: true, usage: getUsage(featureTag) };
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : "Unknown error";
      if (throwOnLimitExceeded) throw error;
      return {
        success: false,
        reason: "tracking_failed",
        error: errorMessage
      };
    }
  }, [context, hasFeature, getUsage]);
  const checkMultipleFeatures = (0, import_react7.useCallback)(async (featureTags, requireAll = true) => {
    const results = featureTags.reduce((acc, tag) => {
      const feature = context.getFeature(tag);
      acc[tag] = {
        hasAccess: feature?.hasAccess || false,
        feature,
        config: feature?.config,
        limits: feature?.limits,
        reason: feature?.reason
      };
      return acc;
    }, {});
    const hasAccess = requireAll ? featureTags.every((tag) => results[tag].hasAccess) : featureTags.some((tag) => results[tag].hasAccess);
    return { hasAccess, results };
  }, [context]);
  const getFeatureWithUsage = (0, import_react7.useCallback)(async (featureTag) => {
    const feature = context.getFeature(featureTag);
    const usage = getUsage(featureTag);
    return {
      hasAccess: feature?.hasAccess || false,
      feature,
      config: feature?.config,
      limits: feature?.limits,
      reason: feature?.reason,
      usage,
      name: featureTag,
      tag: featureTag
    };
  }, [context, getUsage]);
  return {
    // All original context methods and properties
    ...context,
    // Additional convenience methods
    hasFeature,
    getFeature,
    getUsage,
    isTrialing,
    isSubscribed,
    upgradeUrl,
    billingUrl,
    // Enhanced methods
    trackUsageWithCheck,
    checkMultipleFeatures,
    getFeatureWithUsage
  };
}
function useFeature2(featureTag) {
  const { getFeature, hasFeature, loading } = useUseCelo();
  const feature = getFeature(featureTag);
  return {
    hasAccess: hasFeature(featureTag),
    feature,
    config: feature?.config,
    limits: feature?.limits,
    usage: feature?.usage,
    loading
  };
}
function useSubscription() {
  const { subscription, loading, refreshFeatures } = useUseCelo();
  return {
    subscription,
    isTrialing: subscription?.status === "trialing",
    isSubscribed: subscription?.status === "active" || subscription?.status === "trialing",
    loading,
    refresh: refreshFeatures
  };
}
function useUsage() {
  const { trackSingleUsage, trackUsage, getFeature, features } = useUseCelo();
  const getAllUsage = (0, import_react7.useCallback)(() => {
    return features.reduce((acc, feature) => {
      if (typeof feature.usage === "number") {
        acc[feature.tag] = feature.usage;
      }
      return acc;
    }, {});
  }, [features]);
  return {
    trackUsage: trackSingleUsage,
    trackBatchUsage: trackUsage,
    getUsage: (featureTag) => {
      const feature = getFeature(featureTag);
      return typeof feature?.usage === "number" ? feature.usage : null;
    },
    getAllUsage
  };
}

// src/hooks/usePricingTableConfig.ts
var import_react8 = require("react");
function usePricingTableConfig({
  appId,
  apiUrl = "https://use-pricing.vercel.app"
}) {
  const [config, setConfig] = (0, import_react8.useState)(null);
  const [loading, setLoading] = (0, import_react8.useState)(true);
  const [error, setError] = (0, import_react8.useState)(null);
  (0, import_react8.useEffect)(() => {
    const fetchConfig = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await fetch(
          `${apiUrl}/api/public/pricing-table-config/${appId}`
        );
        if (!response.ok) {
          throw new Error(`Failed to fetch pricing table config: ${response.statusText}`);
        }
        const data = await response.json();
        if (!data.success) {
          throw new Error(data.error || "Failed to fetch pricing table config");
        }
        setConfig(data.data);
      } catch (err) {
        setError(err instanceof Error ? err : new Error("Unknown error occurred"));
        setConfig(null);
      } finally {
        setLoading(false);
      }
    };
    if (appId) {
      fetchConfig();
    }
  }, [appId, apiUrl]);
  return { config, loading, error };
}

// src/hooks/useCheckoutFlow.ts
var import_react9 = require("react");
init_UseCeloProvider();
function useCheckoutFlow(options = {}) {
  const [isProcessing, setIsProcessing] = (0, import_react9.useState)(false);
  const [error, setError] = (0, import_react9.useState)(null);
  const { userId: userIdFromContext, appId, apiHost } = useUseCelo();
  const { createCheckout, getCheckoutUrl, isReady, gateway } = useCheckout();
  const {
    successUrl = typeof window !== "undefined" ? `${window.location.origin}/checkout/success` : "/checkout/success",
    cancelUrl = typeof window !== "undefined" ? window.location.href : "/pricing",
    onAuthRequired,
    authRedirectUrl = "/login",
    externalAuth,
    allowPromotionCodes = true,
    mode = "subscription",
    onCheckoutStarted,
    onCheckoutError,
    useDefaultPages = false,
    testMode = false,
    hardcodedUserId
  } = options;
  const startCheckout = (0, import_react9.useCallback)(async (planId, customOptions) => {
    try {
      setIsProcessing(true);
      setError(null);
      console.log("\u{1F6D2} Starting checkout for plan:", planId);
      console.log("\u2705 Step 1: Checking payment configuration...");
      if (!isReady) {
        console.log("\u274C Payment system is not configured");
        throw new Error("Payment system is not configured");
      }
      console.log("\u2705 Payment system is configured");
      console.log("\u2705 Step 2: Checking authentication...");
      let finalIsAuthenticated;
      let finalUser;
      if (hardcodedUserId) {
        finalIsAuthenticated = true;
        finalUser = { id: hardcodedUserId, email: `test-${hardcodedUserId}@example.com` };
        console.log("\u{1F9EA} Using hardcoded userId for testing:", hardcodedUserId);
      } else if (externalAuth) {
        finalIsAuthenticated = externalAuth.isAuthenticated;
        finalUser = externalAuth.user;
        console.log("\u{1F510} Using external auth:", externalAuth.user?.id);
      } else if (userIdFromContext) {
        const resolvedUserId = typeof userIdFromContext === "function" ? await userIdFromContext() : userIdFromContext;
        if (resolvedUserId) {
          finalIsAuthenticated = true;
          finalUser = { id: resolvedUserId };
          console.log("\u2705 Using userId from context:", resolvedUserId);
        } else {
          finalIsAuthenticated = false;
          finalUser = null;
        }
      } else {
        finalIsAuthenticated = false;
        finalUser = null;
      }
      console.log("\u{1F50D} Auth state determination:", {
        hardcodedUserId: hardcodedUserId || null,
        hasExternalAuth: !!externalAuth,
        externalAuth: externalAuth ? {
          isAuthenticated: externalAuth.isAuthenticated,
          userId: externalAuth.user?.id
        } : null,
        final: {
          isAuthenticated: finalIsAuthenticated,
          userId: finalUser?.id
        }
      });
      if (!finalIsAuthenticated || !finalUser?.id) {
        console.log("\u{1F510} Authentication required for checkout");
        console.log("Auth redirect URL:", authRedirectUrl);
        if (typeof window !== "undefined") {
          sessionStorage.setItem("usecelo_pending_checkout", JSON.stringify({
            planId,
            timestamp: Date.now(),
            options: customOptions
          }));
        }
        if (onAuthRequired) {
          console.log("Using custom onAuthRequired handler");
          await onAuthRequired(planId);
        } else if (authRedirectUrl) {
          console.log("Redirecting to auth page:", authRedirectUrl);
          if (typeof window !== "undefined") {
            const currentUrl = window.location.href;
            const redirectUrl = `${authRedirectUrl}?redirect_url=${encodeURIComponent(currentUrl)}&plan=${planId}`;
            console.log("Full redirect URL:", redirectUrl);
            window.location.href = redirectUrl;
          }
        } else {
          console.error("No authentication method available. Please sign in to continue.");
          throw new Error("Authentication required. Please provide authRedirectUrl or onAuthRequired handler.");
        }
        return;
      }
      console.log("\u2705 User is authenticated:", finalUser.id);
      console.log("\u2705 Step 3: Notifying checkout started...");
      onCheckoutStarted?.(planId);
      console.log("\u2705 Step 4: Building checkout options...");
      const origin = process.env.NEXT_PUBLIC_APP_URL || (typeof window !== "undefined" ? window.location.origin : "http://localhost:3000");
      const clientSuccessUrl = successUrl.startsWith("http") ? successUrl : `${origin}${successUrl}`;
      const clientCancelUrl = cancelUrl.startsWith("http") ? cancelUrl : `${origin}${cancelUrl}`;
      const hostedSuccessUrl = `${apiHost}/api/public/checkout/success/${appId}`;
      const hostedCancelUrl = `${apiHost}/api/public/checkout/cancel/${appId}`;
      console.log("\u{1F517} Using hosted checkout URLs:", {
        success: hostedSuccessUrl,
        cancel: hostedCancelUrl,
        clientRedirects: {
          success: clientSuccessUrl,
          cancel: clientCancelUrl
        }
      });
      const checkoutOptions = {
        planId,
        // Use UseCelo hosted URLs with client redirect URLs as query params
        successUrl: useDefaultPages ? `${hostedSuccessUrl}?session_id={CHECKOUT_SESSION_ID}&client_success=${encodeURIComponent(`${origin}/checkout/success`)}` : `${hostedSuccessUrl}?session_id={CHECKOUT_SESSION_ID}&client_success=${encodeURIComponent(clientSuccessUrl)}`,
        cancelUrl: useDefaultPages ? `${hostedCancelUrl}?plan=${planId}&client_cancel=${encodeURIComponent(`${origin}/pricing`)}` : `${hostedCancelUrl}?plan=${planId}&client_cancel=${encodeURIComponent(clientCancelUrl)}`,
        userId: finalUser.id,
        email: finalUser.email,
        metadata: {
          planId,
          userId: finalUser.id,
          source: "pricing_table",
          timestamp: (/* @__PURE__ */ new Date()).toISOString(),
          mode,
          allowPromotionCodes: allowPromotionCodes.toString()
        },
        ...customOptions
      };
      console.log("\u{1F4E1} Creating checkout session with options:", checkoutOptions);
      console.log("\u2705 Step 5: Creating checkout session...");
      if (testMode) {
        console.log("\u{1F9EA} Test mode: Simulating checkout");
        const mockUrl = `/mock-checkout?plan=${planId}&user=${finalUser.id}`;
        await new Promise((resolve) => setTimeout(resolve, 1e3));
        if (typeof window !== "undefined") {
          window.location.href = mockUrl;
        }
      } else {
        console.log("\u{1F504} Creating real checkout session...");
        const session = await createCheckout(checkoutOptions);
        console.log("\u2705 Checkout session created:", session);
        console.log("\u{1F680} Redirecting to Stripe:", session.url);
        if (typeof window !== "undefined") {
          console.log("\u{1F310} Performing redirect...");
          window.location.href = session.url;
        } else {
          console.log("\u274C Window not available for redirect");
        }
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Checkout failed";
      console.error("\u274C Checkout error:", errorMessage);
      setError(errorMessage);
      onCheckoutError?.(errorMessage, planId);
    } finally {
      setIsProcessing(false);
    }
  }, [
    isReady,
    createCheckout,
    successUrl,
    cancelUrl,
    onAuthRequired,
    authRedirectUrl,
    allowPromotionCodes,
    mode,
    onCheckoutStarted,
    onCheckoutError,
    useDefaultPages,
    testMode
  ]);
  const resumePendingCheckout = (0, import_react9.useCallback)(async () => {
    return;
    if (typeof window === "undefined") return;
    const pendingData = sessionStorage.getItem("usecelo_pending_checkout");
    if (!pendingData) return;
    try {
      const { planId, timestamp, options: options2 } = JSON.parse(pendingData);
      if (Date.now() - timestamp > 10 * 60 * 1e3) {
        sessionStorage.removeItem("usecelo_pending_checkout");
        return;
      }
      console.log("\u{1F504} Resuming pending checkout for plan:", planId);
      sessionStorage.removeItem("usecelo_pending_checkout");
      await startCheckout(planId, options2);
    } catch (err) {
      console.error("Failed to resume checkout:", err);
      sessionStorage.removeItem("usecelo_pending_checkout");
    }
  }, [startCheckout]);
  return {
    // Main checkout function
    startCheckout,
    // Resume after auth
    resumePendingCheckout,
    // State
    isProcessing,
    error,
    isReady,
    gateway
  };
}
function useCheckoutSuccess() {
  const [sessionId, setSessionId] = (0, import_react9.useState)(null);
  const [planId, setPlanId] = (0, import_react9.useState)(null);
  const { refreshFeatures } = useUseCelo();
  (0, import_react9.useEffect)(() => {
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window.location.search);
    const session = params.get("session_id");
    const plan = params.get("plan");
    if (session) {
      setSessionId(session);
      setPlanId(plan);
      refreshFeatures();
      sessionStorage.removeItem("usecelo_pending_checkout");
    }
  }, [refreshFeatures]);
  return {
    sessionId,
    planId,
    isSuccess: !!sessionId
  };
}
function useCheckoutCancel() {
  const [planId, setPlanId] = (0, import_react9.useState)(null);
  (0, import_react9.useEffect)(() => {
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window.location.search);
    const plan = params.get("plan");
    if (plan) {
      setPlanId(plan);
    }
  }, []);
  return {
    planId,
    isCancelled: true
  };
}

// src/components/UserIdProvider.tsx
var import_react10 = require("react");
function UserIdProvider({ getUserId, deps = [], onUserIdChange }) {
  const lastUserIdRef = (0, import_react10.useRef)(null);
  (0, import_react10.useEffect)(() => {
    const updateUserId = async () => {
      const userId = await getUserId();
      if (userId !== lastUserIdRef.current) {
        lastUserIdRef.current = userId;
        onUserIdChange?.(userId);
        if (typeof window !== "undefined") {
          window.__usecelo_userId = userId;
          window.dispatchEvent(new CustomEvent("usecelo:user-changed", {
            detail: { userId }
          }));
        }
      }
    };
    updateUserId();
  }, deps);
  return null;
}

// src/components/PricingTable.tsx
var import_react12 = require("react");
init_UseCeloProvider();

// src/components/CheckoutButton.tsx
var import_react11 = require("react");
init_UseCeloProvider();
var import_jsx_runtime7 = require("react/jsx-runtime");
function CheckoutButton({
  planId,
  userId,
  email,
  successUrl,
  cancelUrl,
  metadata,
  trialDays,
  quantity,
  couponCode,
  loadingText = "Processing...",
  errorText,
  onSuccess,
  onCheckoutError,
  openInNewTab = false,
  requireConfirmation = false,
  confirmationMessage = "Proceed to checkout?",
  children = "Checkout",
  disabled,
  className = "",
  ...buttonProps
}) {
  const { initiateCheckout, isReady, gateway } = useCheckout();
  const [isLoading, setIsLoading] = (0, import_react11.useState)(false);
  const [error, setError] = (0, import_react11.useState)(null);
  const handleCheckout = (0, import_react11.useCallback)(async () => {
    if (requireConfirmation && !window.confirm(confirmationMessage)) {
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      const checkoutOptions = {
        userId,
        email,
        successUrl,
        cancelUrl,
        metadata,
        trialDays,
        quantity,
        couponCode
      };
      if (openInNewTab) {
        const { getCheckoutUrl } = require("./UseCeloProvider").useUseCelo();
        const url = await getCheckoutUrl(planId, checkoutOptions);
        window.open(url, "_blank");
        onSuccess?.(url);
      } else {
        await initiateCheckout(planId, checkoutOptions);
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Checkout failed";
      setError(errorMessage);
      onCheckoutError?.(err instanceof Error ? err : new Error(errorMessage));
    } finally {
      setIsLoading(false);
    }
  }, [
    planId,
    userId,
    email,
    successUrl,
    cancelUrl,
    metadata,
    trialDays,
    quantity,
    couponCode,
    requireConfirmation,
    confirmationMessage,
    openInNewTab,
    initiateCheckout,
    onSuccess,
    onCheckoutError
  ]);
  const isDisabled = disabled || !isReady || isLoading;
  const displayError = error || errorText;
  const getButtonText = () => {
    if (isLoading) return loadingText;
    if (displayError && errorText) return errorText;
    return children;
  };
  return /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)(import_jsx_runtime7.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
      "button",
      {
        ...buttonProps,
        className,
        disabled: isDisabled,
        onClick: handleCheckout,
        "aria-busy": isLoading,
        "aria-disabled": isDisabled,
        "data-gateway": gateway,
        children: getButtonText()
      }
    ),
    displayError && !errorText && /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
      "div",
      {
        className: "checkout-error",
        style: {
          color: "red",
          fontSize: "0.875rem",
          marginTop: "0.5rem"
        },
        children: displayError
      }
    )
  ] });
}
function useCheckoutButton(planId, options) {
  const { initiateCheckout, isReady, gateway } = useCheckout();
  const [isLoading, setIsLoading] = (0, import_react11.useState)(false);
  const [error, setError] = (0, import_react11.useState)(null);
  const checkout = (0, import_react11.useCallback)(async () => {
    setIsLoading(true);
    setError(null);
    try {
      await initiateCheckout(planId, options);
    } catch (err) {
      const error2 = err instanceof Error ? err : new Error("Checkout failed");
      setError(error2);
      throw error2;
    } finally {
      setIsLoading(false);
    }
  }, [planId, options, initiateCheckout]);
  return {
    checkout,
    isLoading,
    isReady,
    error,
    gateway
  };
}

// src/components/PricingTable.tsx
var LucideIcons = __toESM(require("lucide-react"));
var import_jsx_runtime8 = require("react/jsx-runtime");
function PricingTable({
  appId: propAppId,
  publicKey: propPublicKey,
  apiHost: propApiHost,
  upgradePageUrl,
  onSelectPlan,
  className = "",
  highlightPlanId,
  showAnnualToggle = false,
  useCheckoutButton: useCheckoutButton2 = false,
  successUrl,
  cancelUrl,
  openInNewTab = false,
  requireConfirmation = false,
  confirmationMessage = "Proceed to checkout?",
  onCheckoutSuccess,
  onCheckoutError,
  // New checkout flow props
  enableDirectCheckout = false,
  onAuthRequired,
  authRedirectUrl,
  testMode = false,
  allowPromotionCodes = true,
  useDefaultPages = false,
  hardcodedUserId,
  externalAuth,
  useRemoteConfig = false
}) {
  const [plans, setPlans] = (0, import_react12.useState)([]);
  const [loading, setLoading] = (0, import_react12.useState)(true);
  const [error, setError] = (0, import_react12.useState)(null);
  const [billingCycle, setBillingCycle] = (0, import_react12.useState)("monthly");
  let contextConfig = null;
  try {
    contextConfig = useUseCelo();
  } catch {
  }
  const appId = propAppId || contextConfig?.appId;
  const publicKey = propPublicKey || contextConfig?.publicKey;
  const apiHost = propApiHost || contextConfig?.apiHost || "http://localhost:3000";
  const { config: remoteConfig, loading: configLoading } = usePricingTableConfig({
    appId: useRemoteConfig ? appId || "" : "",
    apiUrl: apiHost
  });
  const checkoutFlow = enableDirectCheckout ? useCheckoutFlow({
    successUrl,
    cancelUrl,
    onAuthRequired,
    authRedirectUrl,
    allowPromotionCodes,
    useDefaultPages,
    testMode,
    hardcodedUserId,
    // Pass hardcoded userId for testing
    // Pass external auth if provided
    externalAuth,
    onCheckoutStarted: (planId) => {
      console.log(`\u{1F6D2} PricingTable: Starting checkout for plan: ${planId}`);
    },
    onCheckoutError: (errorMessage, planId) => {
      console.error(`\u274C PricingTable: Checkout error for plan ${planId}:`, errorMessage);
      if (onCheckoutError) {
        onCheckoutError(new Error(errorMessage), planId);
      }
    }
  }) : null;
  const finalAuthState = {
    isAuthenticated: externalAuth?.isAuthenticated || false,
    user: externalAuth?.user || null
  };
  const primaryColor = useRemoteConfig && remoteConfig?.colorScheme?.primary || void 0;
  const accentColor = useRemoteConfig && remoteConfig?.colorScheme?.accent || void 0;
  const textColor = useRemoteConfig && remoteConfig?.colorScheme?.text || void 0;
  const cardPadding = useRemoteConfig && remoteConfig?.spacing?.cardPadding || void 0;
  const borderRadius = useRemoteConfig && remoteConfig?.spacing?.borderRadius || void 0;
  const shadow = useRemoteConfig && remoteConfig?.shadow || void 0;
  const configuredPlanOrder = useRemoteConfig && remoteConfig?.planOrder || void 0;
  const configuredHighlightPlanId = useRemoteConfig && remoteConfig?.highlightedPlanId || highlightPlanId;
  console.log("\u{1F3A8} PricingTable Remote Config:", {
    useRemoteConfig,
    configLoading,
    hasRemoteConfig: !!remoteConfig,
    primaryColor,
    accentColor,
    cardPadding,
    borderRadius,
    configuredPlanOrder,
    configuredHighlightPlanId
  });
  console.log("\u{1F50D} PricingTable render:", {
    enableDirectCheckout,
    hasCheckoutFlow: !!checkoutFlow,
    externalAuth: {
      isAuthenticated: externalAuth?.isAuthenticated || false,
      userId: externalAuth?.user?.id,
      email: externalAuth?.user?.email
    },
    // SDK auth removed - using simplified userId approach
    finalAuth: {
      isAuthenticated: finalAuthState.isAuthenticated,
      userId: finalAuthState.user?.id
    },
    isReady: checkoutFlow?.isReady,
    hardcodedUserId
  });
  if (!appId || !publicKey) {
    console.error(
      "PricingTable: Missing required config. Either provide appId and publicKey as props, or wrap your app with UseCeloProvider."
    );
  }
  (0, import_react12.useEffect)(() => {
    async function fetchPricingTablePlans() {
      if (!appId || !publicKey) {
        setError("Missing required configuration");
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        const res = await fetch(`${apiHost}/api/public/plans/${appId}`, {
          headers: {
            "x-api-key": publicKey
          }
        });
        if (!res.ok) {
          throw new Error("Failed to fetch plans");
        }
        const { data } = await res.json();
        setPlans(data || []);
      } catch (err) {
        setError(err instanceof Error ? err.message : "Failed to load pricing");
      } finally {
        setLoading(false);
      }
    }
    fetchPricingTablePlans();
  }, [appId, publicKey, apiHost]);
  const getPricingDisplay = (pricing) => {
    if (!pricing || typeof pricing !== "object") {
      return { amount: "Free", interval: "", model: "free" };
    }
    const pricingConfig = pricing;
    const currency = pricingConfig.currency || "USD";
    const currencySymbol = currency === "USD" ? "$" : currency;
    if (pricingConfig.model === "free") {
      return { amount: "Free", interval: "", model: "free" };
    }
    if (pricingConfig.model === "usage" || pricingConfig.model === "usage_based") {
      const basePrice = pricingConfig.usage?.tiers?.[0]?.price || pricingConfig.baseFee || 0;
      return {
        amount: basePrice === 0 ? "Free" : `Starting at ${currencySymbol}${basePrice}`,
        interval: basePrice === 0 ? "" : `per ${pricingConfig.usage?.unit || "unit"}`,
        model: "usage"
      };
    }
    const amount = pricingConfig.amount ?? pricingConfig.baseFee ?? pricingConfig.price ?? 0;
    if (amount === 0) {
      return { amount: "Free", interval: "", model: "free" };
    }
    const interval = pricingConfig.interval || pricingConfig.billingCycle || "month";
    const displayAmount = billingCycle === "annual" && showAnnualToggle ? Math.floor(amount * 12 * 0.8) : amount;
    const displayInterval = billingCycle === "annual" && showAnnualToggle ? "year" : interval;
    return {
      amount: `${currencySymbol}${displayAmount}`,
      interval: `/${displayInterval}`,
      model: pricingConfig.model || "flat"
    };
  };
  const getFeatureDisplay = (planFeature) => {
    const config = planFeature.config || {};
    const feature = planFeature.feature;
    if (config.rateLimit) {
      return `${config.rateLimit.toLocaleString()} ${feature.name}/month`;
    }
    if (config.maxUsers) {
      return `Up to ${config.maxUsers} users`;
    }
    if (config.maxStorageGB) {
      return `${config.maxStorageGB} GB storage`;
    }
    if (config.maxItems) {
      return `${config.maxItems} ${feature.name}`;
    }
    if (config.retentionDays) {
      return `${config.retentionDays} days data retention`;
    }
    if (config.enabled === false) {
      return null;
    }
    return feature.name;
  };
  const handleSelectPlan = async (planId) => {
    console.log("\u{1F3AF} PricingTable: handleSelectPlan called with planId:", planId);
    console.log("\u{1F50D} PricingTable: enableDirectCheckout:", enableDirectCheckout);
    console.log("\u{1F50D} PricingTable: finalAuthState:", finalAuthState);
    console.log("\u{1F50D} PricingTable: checkoutFlow exists:", !!checkoutFlow);
    if (enableDirectCheckout && checkoutFlow) {
      console.log("\u2705 PricingTable: Using direct checkout flow");
      console.log("\u{1F50D} Auth check - isAuthenticated:", finalAuthState.isAuthenticated);
      console.log("\u{1F50D} Auth check - user:", finalAuthState.user);
      console.log("\u{1F680} PricingTable: Starting checkout with external auth override");
      try {
        await checkoutFlow.startCheckout(planId);
        console.log("\u2705 PricingTable: Checkout flow completed");
      } catch (error2) {
        console.error("\u274C PricingTable: Checkout flow error:", error2);
      }
      return;
    }
    console.log("\u26A0\uFE0F PricingTable: Using fallback behavior");
    if (onSelectPlan) {
      console.log("\u{1F504} PricingTable: Calling onSelectPlan");
      onSelectPlan(planId);
    } else if (upgradePageUrl) {
      console.log("\u{1F504} PricingTable: Redirecting to upgradePageUrl");
      window.location.href = `${upgradePageUrl}?planId=${planId}`;
    } else {
      console.log("\u274C PricingTable: No action configured for plan selection");
    }
  };
  if (loading) {
    return /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { className: `flex items-center justify-center py-12 ${className}`, children: /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("div", { className: "text-center", children: [
      /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { className: "inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-primary" }),
      /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("p", { className: "mt-4 text-muted-foreground", children: "Loading pricing..." })
    ] }) });
  }
  if (error) {
    return /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { className: `flex items-center justify-center py-12 ${className}`, children: /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("div", { className: "text-center text-red-600", children: [
      /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("p", { children: "Failed to load pricing" }),
      /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("p", { className: "text-sm mt-2", children: error })
    ] }) });
  }
  if (plans.length === 0) {
    return /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { className: `flex items-center justify-center py-12 ${className}`, children: /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { className: "text-center text-muted-foreground", children: /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("p", { children: "No pricing plans available" }) }) });
  }
  const orderedPlansForGrid = configuredPlanOrder ? configuredPlanOrder.map((id) => plans.find((p) => p.id === id)).filter((p) => p !== void 0) : plans;
  return /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("div", { className: `w-full ${className}`, children: [
    showAnnualToggle && /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("div", { className: "flex items-center justify-center mb-8 gap-4", children: [
      /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("span", { className: billingCycle === "monthly" ? "font-semibold" : "text-muted-foreground", children: "Monthly" }),
      /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
        "button",
        {
          onClick: () => setBillingCycle(billingCycle === "monthly" ? "annual" : "monthly"),
          className: "relative inline-flex h-6 w-11 items-center rounded-full bg-gray-200 transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2",
          children: /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
            "span",
            {
              className: `inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${billingCycle === "annual" ? "translate-x-6" : "translate-x-1"}`
            }
          )
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("span", { className: billingCycle === "annual" ? "font-semibold" : "text-muted-foreground", children: [
        "Annual",
        showAnnualToggle && /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("span", { className: "ml-2 text-green-600 text-sm font-medium", children: "Save 20%" })
      ] })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { style: { width: "100%", display: "flex", justifyContent: "center", padding: "0 16px" }, children: /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { style: {
      display: "grid",
      gridTemplateColumns: useRemoteConfig && remoteConfig?.columnsPerRow ? `repeat(${Math.min(remoteConfig.columnsPerRow, orderedPlansForGrid.length)}, 1fr)` : orderedPlansForGrid.length === 1 ? "1fr" : orderedPlansForGrid.length === 2 ? "repeat(2, 1fr)" : "repeat(auto-fit, minmax(300px, 400px))",
      gap: "24px",
      justifyContent: "center",
      width: "100%",
      maxWidth: useRemoteConfig && remoteConfig?.columnsPerRow ? `${remoteConfig.columnsPerRow * 420}px` : void 0
    }, children: (() => {
      const orderedPlans = configuredPlanOrder ? [
        // First: plans in the configured order
        ...configuredPlanOrder.map((id) => plans.find((p) => p.id === id)).filter((p) => p !== void 0),
        // Then: any plans NOT in the configured order (newly added plans)
        ...plans.filter((p) => !configuredPlanOrder.includes(p.id))
      ] : plans;
      return orderedPlans.map((plan, index) => {
        const pricing = getPricingDisplay(plan.pricing);
        const isHighlighted = plan.id === configuredHighlightPlanId || !configuredHighlightPlanId && index === 1;
        if (useRemoteConfig && remoteConfig) {
          const sectionOrder = remoteConfig.sectionOrder || ["title", "description", "price", "cta", "features"];
          const featureOrderForPlan = remoteConfig.featureOrder?.[plan.id] || (plan.features || []).map((_, idx) => idx.toString());
          const savedOrderedFeatures = featureOrderForPlan.map((idx) => plan.features?.[parseInt(idx)]).filter(Boolean);
          const featuresNotInOrder = (plan.features || []).filter(
            (_, idx) => !featureOrderForPlan.includes(idx.toString())
          );
          const orderedFeatures = [...savedOrderedFeatures, ...featuresNotInOrder];
          const sections = {
            title: /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
              "h3",
              {
                style: {
                  fontSize: "24px",
                  fontWeight: remoteConfig.typography?.fontWeight || "bold",
                  fontFamily: remoteConfig.typography?.fontFamily || "inherit",
                  color: textColor || "#111827",
                  marginBottom: "8px"
                },
                children: plan.name
              },
              "title"
            ),
            description: remoteConfig.showDescription && plan.description ? /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("p", { style: { color: textColor || "#4B5563", opacity: 0.7, fontSize: "14px", marginBottom: "16px" }, children: plan.description }, "description") : null,
            price: /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("div", { style: { marginBottom: "24px" }, children: [
              /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("span", { style: { fontSize: "36px", fontWeight: "bold", color: textColor || "#111827" }, children: pricing.amount }),
              /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("span", { style: { color: textColor || "#4B5563", opacity: 0.7, marginLeft: "4px" }, children: pricing.interval })
            ] }, "price"),
            cta: remoteConfig.showCTA ? /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
              "button",
              {
                onClick: () => handleSelectPlan(plan.id),
                disabled: checkoutFlow?.isProcessing,
                "data-plan-id": plan.id,
                style: {
                  width: "100%",
                  padding: "12px 24px",
                  fontWeight: "600",
                  color: "white",
                  transition: "all 0.3s",
                  margin: "24px 0",
                  backgroundColor: primaryColor,
                  borderRadius: borderRadius || "8px",
                  border: "none",
                  cursor: checkoutFlow?.isProcessing ? "not-allowed" : "pointer",
                  opacity: checkoutFlow?.isProcessing ? 0.6 : 1
                },
                children: checkoutFlow?.isProcessing ? "Processing..." : plan.cta || "Get Started"
              },
              "cta"
            ) : null,
            features: remoteConfig.showFeatures && orderedFeatures.length > 0 ? /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("ul", { style: { display: "flex", flexDirection: "column", gap: "12px" }, children: orderedFeatures.map((pf, idx) => {
              const featureIcon = pf.feature.icon;
              const isEmoji = featureIcon && /\p{Emoji}/u.test(featureIcon);
              const IconComponent = featureIcon && !isEmoji ? LucideIcons[featureIcon] : null;
              return /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("li", { style: { display: "flex", alignItems: "flex-start", gap: "8px", fontSize: "14px", color: textColor || "#374151" }, children: [
                IconComponent ? /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
                  IconComponent,
                  {
                    style: {
                      width: "20px",
                      height: "20px",
                      flexShrink: 0,
                      marginTop: "2px",
                      color: accentColor || "#10B981"
                    }
                  }
                ) : featureIcon && isEmoji ? /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("span", { style: {
                  width: "20px",
                  height: "20px",
                  flexShrink: 0,
                  marginTop: "2px",
                  fontSize: "16px",
                  lineHeight: "1"
                }, children: featureIcon }) : /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
                  "svg",
                  {
                    style: {
                      width: "20px",
                      height: "20px",
                      flexShrink: 0,
                      marginTop: "2px",
                      color: accentColor || "#10B981"
                    },
                    fill: "currentColor",
                    viewBox: "0 0 20 20",
                    children: /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
                      "path",
                      {
                        fillRule: "evenodd",
                        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                        clipRule: "evenodd"
                      }
                    )
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("span", { children: pf.feature.name })
              ] }, idx);
            }) }, "features") : null
          };
          return /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)(
            "div",
            {
              className: `relative overflow-hidden transition-all ${isHighlighted ? "ring-2 ring-offset-2" : ""}`,
              style: {
                position: "relative",
                overflow: "hidden",
                backgroundColor: remoteConfig.colorScheme?.background || "white",
                borderRadius: borderRadius || "8px",
                padding: cardPadding || "24px",
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: isHighlighted ? accentColor : "#E5E7EB",
                boxShadow: shadow || void 0,
                width: "100%",
                maxWidth: "400px"
              },
              children: [
                isHighlighted && /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
                  "div",
                  {
                    style: {
                      position: "absolute",
                      top: 0,
                      right: 0,
                      padding: "4px 12px",
                      fontSize: "12px",
                      fontWeight: "600",
                      color: "white",
                      backgroundColor: accentColor || "#10B981"
                    },
                    children: "Recommended"
                  }
                ),
                sectionOrder.map((sectionKey) => sections[sectionKey]).filter(Boolean)
              ]
            },
            plan.id
          );
        }
        return /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)(
          "div",
          {
            className: `relative border-2 shadow-sm transition-all hover:shadow-lg ${!primaryColor ? `rounded-2xl p-6 ${isHighlighted ? "border-primary bg-primary/5 scale-105" : "border-gray-200"}` : ""}`,
            style: primaryColor ? {
              borderRadius: borderRadius || "16px",
              padding: cardPadding || "24px",
              borderColor: "#E5E7EB",
              backgroundColor: "white",
              boxShadow: shadow || void 0
            } : void 0,
            children: [
              isHighlighted && /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { className: "absolute -top-3 left-1/2 -translate-x-1/2", children: /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
                "span",
                {
                  className: `text-white text-xs font-semibold px-3 py-1 rounded-full ${primaryColor ? "" : "bg-primary"}`,
                  style: primaryColor ? { backgroundColor: primaryColor } : {},
                  children: "Most Popular"
                }
              ) }),
              /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("div", { className: "text-center mb-6", children: [
                /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("h3", { className: "text-xl font-bold mb-2", children: plan.name }),
                plan.description && /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("p", { className: "text-sm text-muted-foreground", children: plan.description })
              ] }),
              /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("div", { className: "text-center mb-6", children: [
                /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("div", { className: "flex items-baseline justify-center gap-1", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("span", { className: "text-4xl font-bold", children: pricing.amount }),
                  pricing.interval && /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("span", { className: "text-muted-foreground", children: pricing.interval })
                ] }),
                plan.trialPeriodDays && /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("p", { className: "text-sm text-green-600 mt-2", children: [
                  plan.trialPeriodDays,
                  " day free trial"
                ] })
              ] }),
              /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("ul", { className: "space-y-3 mb-6", children: plan.features?.map((planFeature) => {
                const display = getFeatureDisplay(planFeature);
                if (!display) return null;
                return /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("li", { className: "flex items-start gap-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
                    "svg",
                    {
                      className: "h-5 w-5 text-green-500 mt-0.5 flex-shrink-0",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24",
                      children: /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
                        "path",
                        {
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeWidth: 2,
                          d: "M5 13l4 4L19 7"
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("span", { className: "text-sm", children: display })
                ] }, planFeature.feature.id);
              }) }),
              useCheckoutButton2 ? /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
                CheckoutButton,
                {
                  planId: plan.id,
                  successUrl,
                  cancelUrl,
                  openInNewTab,
                  requireConfirmation,
                  confirmationMessage,
                  onSuccess: onCheckoutSuccess,
                  onCheckoutError: (error2) => onCheckoutError?.(error2, plan.id),
                  className: `w-full py-3 px-4 rounded-lg font-semibold transition-all ${isHighlighted ? "bg-primary text-white hover:bg-primary/90" : "bg-gray-100 text-gray-900 hover:bg-gray-200"}`,
                  children: plan.cta || "Get Started"
                }
              ) : /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
                "button",
                {
                  onClick: () => handleSelectPlan(plan.id),
                  disabled: checkoutFlow?.isProcessing,
                  "data-plan-id": plan.id,
                  className: `w-full py-3 px-4 font-semibold transition-all ${checkoutFlow?.isProcessing ? "bg-gray-300 text-gray-500 cursor-not-allowed rounded-lg" : !primaryColor ? `rounded-lg ${isHighlighted ? "bg-primary text-white hover:bg-primary/90" : "bg-gray-100 text-gray-900 hover:bg-gray-200"}` : ""}`,
                  style: !checkoutFlow?.isProcessing && primaryColor ? {
                    backgroundColor: primaryColor,
                    color: "white",
                    borderRadius: borderRadius || "8px"
                  } : void 0,
                  children: checkoutFlow?.isProcessing ? "Processing..." : plan.cta || "Get Started"
                }
              )
            ]
          },
          plan.id
        );
      });
    })() }) })
  ] });
}

// src/components/CheckoutSuccess.tsx
var import_react13 = __toESM(require("react"));
var import_jsx_runtime9 = require("react/jsx-runtime");
function CheckoutSuccess({
  onSuccess,
  redirectUrl,
  redirectDelay = 3e3,
  className = "",
  showConfetti = true
}) {
  const { sessionId, planId, isSuccess } = useCheckoutSuccess();
  import_react13.default.useEffect(() => {
    if (isSuccess && sessionId) {
      onSuccess?.(sessionId, planId);
      if (redirectUrl) {
        setTimeout(() => {
          window.location.href = redirectUrl;
        }, redirectDelay);
      }
    }
  }, [isSuccess, sessionId, planId, onSuccess, redirectUrl, redirectDelay]);
  if (!isSuccess) {
    return /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { className: `flex items-center justify-center min-h-screen ${className}`, children: /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("div", { className: "text-center", children: [
      /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { className: "inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-primary" }),
      /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("p", { className: "mt-4 text-muted-foreground", children: "Processing payment..." })
    ] }) });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { className: `flex items-center justify-center min-h-screen ${className}`, children: /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("div", { className: "text-center max-w-md", children: [
    showConfetti && /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { className: "text-6xl mb-6", children: "\u{1F389}" }),
    /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
      "svg",
      {
        className: "mx-auto h-16 w-16 text-green-500 mb-6",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24",
        children: /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
          "path",
          {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          }
        )
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("h1", { className: "text-3xl font-bold mb-4", children: "Payment Successful!" }),
    /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("p", { className: "text-lg text-muted-foreground mb-6", children: "Thank you for your purchase. Your subscription is now active." }),
    planId && /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("p", { className: "text-sm text-muted-foreground mb-4", children: [
      "Plan ID: ",
      /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("span", { className: "font-mono", children: planId })
    ] }),
    redirectUrl && /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("p", { className: "text-sm text-muted-foreground", children: [
      "Redirecting in ",
      Math.ceil(redirectDelay / 1e3),
      " seconds..."
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { className: "mt-8", children: /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
      "button",
      {
        onClick: () => window.location.href = redirectUrl || "/",
        className: "bg-primary text-white px-6 py-3 rounded-lg font-semibold hover:bg-primary/90 transition",
        children: "Continue to Dashboard"
      }
    ) })
  ] }) });
}

// src/components/CheckoutCancel.tsx
var import_react14 = __toESM(require("react"));
var import_jsx_runtime10 = require("react/jsx-runtime");
function CheckoutCancel({
  onCancel,
  retryUrl,
  redirectUrl,
  className = "",
  showRetryButton = true
}) {
  const { planId, isCancelled } = useCheckoutCancel();
  import_react14.default.useEffect(() => {
    if (isCancelled) {
      onCancel?.(planId);
    }
  }, [isCancelled, planId, onCancel]);
  const handleRetry = () => {
    if (retryUrl) {
      window.location.href = retryUrl;
    } else {
      window.history.back();
    }
  };
  const handleGoHome = () => {
    window.location.href = redirectUrl || "/";
  };
  return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("div", { className: `flex items-center justify-center min-h-screen ${className}`, children: /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)("div", { className: "text-center max-w-md", children: [
    /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
      "svg",
      {
        className: "mx-auto h-16 w-16 text-gray-400 mb-6",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24",
        children: /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
          "path",
          {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M6 18L18 6M6 6l12 12"
          }
        )
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("h1", { className: "text-3xl font-bold mb-4", children: "Payment Cancelled" }),
    /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("p", { className: "text-lg text-muted-foreground mb-6", children: "Your payment was cancelled. No charges have been made to your account." }),
    planId && /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)("p", { className: "text-sm text-muted-foreground mb-6", children: [
      "You were trying to subscribe to: ",
      /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("span", { className: "font-mono", children: planId })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)("div", { className: "space-y-3", children: [
      showRetryButton && /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
        "button",
        {
          onClick: handleRetry,
          className: "w-full bg-primary text-white px-6 py-3 rounded-lg font-semibold hover:bg-primary/90 transition",
          children: "Try Again"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
        "button",
        {
          onClick: handleGoHome,
          className: "w-full bg-gray-100 text-gray-900 px-6 py-3 rounded-lg font-semibold hover:bg-gray-200 transition",
          children: "Back to Home"
        }
      )
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("p", { className: "text-xs text-muted-foreground mt-6", children: "Need help? Contact our support team." })
  ] }) });
}

// src/components/Feature.tsx
init_UseCeloProvider();
var import_jsx_runtime11 = require("react/jsx-runtime");
function Feature2({
  name,
  children,
  fallback = null,
  loading = null
}) {
  const { hasFeature, loading: contextLoading } = useUseCelo();
  if (contextLoading) {
    return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_jsx_runtime11.Fragment, { children: loading });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_jsx_runtime11.Fragment, { children: hasFeature(name) ? children : fallback });
}
function MultiFeatures({
  features,
  children,
  fallback = null,
  loading = null,
  requireAll = true,
  renderPartial
}) {
  const { hasFeature, loading: contextLoading } = useUseCelo();
  if (contextLoading) {
    return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_jsx_runtime11.Fragment, { children: loading });
  }
  const availableFeatures = features.filter((feature) => hasFeature(feature));
  const hasRequiredAccess = requireAll ? features.every((feature) => hasFeature(feature)) : availableFeatures.length > 0;
  if (renderPartial && availableFeatures.length > 0 && (!requireAll || !hasRequiredAccess)) {
    return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_jsx_runtime11.Fragment, { children: renderPartial(availableFeatures) });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_jsx_runtime11.Fragment, { children: hasRequiredAccess ? children : fallback });
}
function withFeatureGate(WrappedComponent, featureName, fallback) {
  const FeatureGatedComponent = (props) => /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(Feature2, { name: featureName, fallback, children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(WrappedComponent, { ...props }) });
  FeatureGatedComponent.displayName = `withFeatureGate(${WrappedComponent.displayName || WrappedComponent.name})`;
  return FeatureGatedComponent;
}
function TrialOnly({
  children,
  fallback = null,
  loading = null,
  showDaysRemaining = false
}) {
  const { isTrialing, loading: contextLoading } = usePricing();
  if (contextLoading) {
    return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_jsx_runtime11.Fragment, { children: loading });
  }
  if (!isTrialing) {
    return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_jsx_runtime11.Fragment, { children: fallback });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)(import_jsx_runtime11.Fragment, { children: [
    children,
    showDaysRemaining && /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { style: { fontSize: "0.875rem", color: "#6b7280", marginTop: "0.5rem" }, children: "Trial period active" })
  ] });
}
function UpgradePrompt({
  feature,
  title = "Upgrade Required",
  description,
  buttonText = "Upgrade Now",
  onUpgrade,
  className = ""
}) {
  const { upgradeUrl } = usePricing();
  const defaultDescription = `Access to ${feature.replace(/[_-]/g, " ")} requires an upgraded plan.`;
  const handleUpgrade = () => {
    if (onUpgrade) {
      onUpgrade();
    } else {
      window.open(upgradeUrl, "_blank");
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)("div", { className: `border-2 border-dashed border-gray-300 rounded-lg p-6 text-center bg-gray-50 ${className}`, children: [
    /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { className: "text-gray-900 font-medium mb-2", children: title }),
    /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { className: "text-gray-600 text-sm mb-4", children: description || defaultDescription }),
    /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
      "button",
      {
        onClick: handleUpgrade,
        className: "inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500",
        children: buttonText
      }
    )
  ] });
}
function PlanTier({
  children,
  plans,
  fallback = null,
  loading = null
}) {
  const { userPlan, loading: contextLoading } = useUseCelo();
  if (contextLoading) {
    return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_jsx_runtime11.Fragment, { children: loading });
  }
  const currentPlanName = userPlan?.name;
  if (currentPlanName && plans[currentPlanName]) {
    return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_jsx_runtime11.Fragment, { children: plans[currentPlanName] });
  }
  if (currentPlanName) {
    return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_jsx_runtime11.Fragment, { children });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_jsx_runtime11.Fragment, { children: fallback });
}
function SubscriptionGate({
  children,
  fallback = null,
  loading = null,
  requireActive = true,
  requirePaid = false,
  showForTrial = true
}) {
  const { isSubscribed, isTrialing, loading: contextLoading } = usePricing();
  if (contextLoading) {
    return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_jsx_runtime11.Fragment, { children: loading });
  }
  const hasValidSubscription = isSubscribed && (showForTrial || !isTrialing);
  const meetsRequirements = requireActive ? hasValidSubscription : true;
  if (requirePaid && isTrialing) {
    return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_jsx_runtime11.Fragment, { children: fallback });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_jsx_runtime11.Fragment, { children: meetsRequirements ? children : fallback });
}

// src/components/UsageComponents.tsx
var import_react15 = __toESM(require("react"));
var import_jsx_runtime12 = require("react/jsx-runtime");
function UsageDisplay({
  feature,
  showLabel = true,
  className = ""
}) {
  const { getUsage } = useUsage();
  const usage = getUsage(feature);
  return /* @__PURE__ */ (0, import_jsx_runtime12.jsxs)("div", { className: `usage-display ${className}`, children: [
    showLabel && /* @__PURE__ */ (0, import_jsx_runtime12.jsxs)("span", { className: "usage-label", children: [
      feature.replace(/[_-]/g, " ").replace(/\b\w/g, (l) => l.toUpperCase()),
      ":"
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime12.jsx)("span", { className: "usage-value", children: usage !== null ? usage : 0 })
  ] });
}
function MultiUsageDisplay({
  features,
  title = "Usage Overview",
  className = ""
}) {
  const { getAllUsage } = useUsage();
  const allUsage = getAllUsage();
  const relevantUsage = (0, import_react15.useMemo)(() => {
    return features.reduce((acc, feature) => {
      acc[feature] = allUsage[feature] || 0;
      return acc;
    }, {});
  }, [features, allUsage]);
  return /* @__PURE__ */ (0, import_jsx_runtime12.jsxs)("div", { className: `multi-usage-display ${className}`, children: [
    title && /* @__PURE__ */ (0, import_jsx_runtime12.jsx)("h3", { className: "usage-title", children: title }),
    /* @__PURE__ */ (0, import_jsx_runtime12.jsx)("div", { className: "usage-grid", children: Object.entries(relevantUsage).map(([feature, usage]) => /* @__PURE__ */ (0, import_jsx_runtime12.jsxs)("div", { className: "usage-item", children: [
      /* @__PURE__ */ (0, import_jsx_runtime12.jsx)("div", { className: "usage-feature-name", children: feature.replace(/[_-]/g, " ").replace(/\b\w/g, (l) => l.toUpperCase()) }),
      /* @__PURE__ */ (0, import_jsx_runtime12.jsx)("div", { className: "usage-feature-value", children: usage })
    ] }, feature)) })
  ] });
}
function UsageTracker({
  feature,
  showLabel = true,
  onUsageChange,
  autoRefresh = false,
  refreshInterval = 3e4,
  className = ""
}) {
  const { getUsage } = useUsage();
  const { refreshFeatures } = usePricing();
  const usage = getUsage(feature);
  import_react15.default.useEffect(() => {
    if (!autoRefresh) return;
    const interval = setInterval(() => {
      refreshFeatures();
    }, refreshInterval);
    return () => clearInterval(interval);
  }, [autoRefresh, refreshInterval, refreshFeatures]);
  import_react15.default.useEffect(() => {
    if (usage !== null && onUsageChange) {
      onUsageChange(usage);
    }
  }, [usage, onUsageChange]);
  return /* @__PURE__ */ (0, import_jsx_runtime12.jsxs)("div", { className: `usage-tracker ${className}`, children: [
    /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(UsageDisplay, { feature, showLabel }),
    autoRefresh && /* @__PURE__ */ (0, import_jsx_runtime12.jsxs)("div", { className: "usage-refresh-indicator", style: { fontSize: "0.75rem", color: "#666" }, children: [
      "Auto-refreshing every ",
      Math.floor(refreshInterval / 1e3),
      "s"
    ] })
  ] });
}
function UsageControl({
  feature,
  showLabel = true,
  incrementValue = 1,
  showControls = true,
  onTrack,
  className = ""
}) {
  const { trackUsage } = useUsage();
  const [isTracking, setIsTracking] = import_react15.default.useState(false);
  const handleTrack = async () => {
    setIsTracking(true);
    try {
      await trackUsage(feature, incrementValue);
      onTrack?.(feature, incrementValue);
    } catch (error) {
      console.error("Failed to track usage:", error);
    } finally {
      setIsTracking(false);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime12.jsxs)("div", { className: `usage-control ${className}`, children: [
    /* @__PURE__ */ (0, import_jsx_runtime12.jsx)("div", { className: "usage-display-section", children: /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(UsageDisplay, { feature, showLabel }) }),
    showControls && /* @__PURE__ */ (0, import_jsx_runtime12.jsx)("div", { className: "usage-controls", children: /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
      "button",
      {
        onClick: handleTrack,
        disabled: isTracking,
        className: "usage-increment-btn",
        style: {
          padding: "4px 8px",
          backgroundColor: "#10b981",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: isTracking ? "not-allowed" : "pointer",
          opacity: isTracking ? 0.6 : 1
        },
        children: isTracking ? "Tracking..." : `+${incrementValue}`
      }
    ) })
  ] });
}
function useUsageStats(features) {
  const { getAllUsage } = useUsage();
  const allUsage = getAllUsage();
  return (0, import_react15.useMemo)(() => {
    const relevantUsage = features.reduce((acc, feature) => {
      acc[feature] = allUsage[feature] || 0;
      return acc;
    }, {});
    const total = Object.values(relevantUsage).reduce((sum, usage) => sum + usage, 0);
    const average = features.length > 0 ? total / features.length : 0;
    const max = Math.max(...Object.values(relevantUsage), 0);
    const min = Math.min(...Object.values(relevantUsage), 0);
    return {
      usage: relevantUsage,
      total,
      average: Math.round(average * 100) / 100,
      max,
      min,
      features: features.length
    };
  }, [features, allUsage]);
}

// src/components/subscription-manager/SimplifiedSubscriptionManager.tsx
var import_react16 = require("react");
init_UseCeloProvider();
var import_jsx_runtime13 = require("react/jsx-runtime");
function SimplifiedSubscriptionManager({
  theme = "light",
  onCancelComplete,
  onPlanChangeComplete,
  onError,
  className = ""
} = {}) {
  const {
    loading: contextLoading,
    appId,
    publicKey,
    apiHost,
    getSubscription,
    createCheckout,
    cancelSubscription,
    pauseSubscription,
    resumeSubscription
  } = useUseCelo();
  const [subscription, setSubscription] = (0, import_react16.useState)(null);
  const [plans, setPlans] = (0, import_react16.useState)([]);
  const [showCancelConfirm, setShowCancelConfirm] = (0, import_react16.useState)(false);
  const [showPlanSelector, setShowPlanSelector] = (0, import_react16.useState)(false);
  const [isProcessing, setIsProcessing] = (0, import_react16.useState)(false);
  const [isLoadingPlans, setIsLoadingPlans] = (0, import_react16.useState)(false);
  const [isLoadingSubscription, setIsLoadingSubscription] = (0, import_react16.useState)(false);
  const [error, setError] = (0, import_react16.useState)(null);
  const [successMessage, setSuccessMessage] = (0, import_react16.useState)(null);
  const [userId, setUserId] = (0, import_react16.useState)(null);
  (0, import_react16.useEffect)(() => {
    const fetchSubscription = async () => {
      if (!getSubscription) return;
      setIsLoadingSubscription(true);
      try {
        const data = await getSubscription();
        console.log("\u2705 Fetched subscription data:", data);
        if (data) {
          setSubscription(data.subscription);
          if (data.user?.externalId) {
            setUserId(data.user.externalId);
          }
        }
      } catch (err) {
        console.error("\u274C Failed to fetch subscription:", err);
        setError(err instanceof Error ? err.message : "Failed to load subscription");
      } finally {
        setIsLoadingSubscription(false);
      }
    };
    fetchSubscription();
  }, [getSubscription]);
  (0, import_react16.useEffect)(() => {
    const fetchPlans = async () => {
      if (!appId || !publicKey || !apiHost) return;
      setIsLoadingPlans(true);
      try {
        const response = await fetch(`${apiHost}/api/public/plans/${appId}`, {
          headers: {
            "x-api-key": publicKey
          }
        });
        if (response.ok) {
          const data = await response.json();
          setPlans(data.data || data.plans || []);
        }
      } catch (err) {
        console.error("Failed to fetch plans:", err);
      } finally {
        setIsLoadingPlans(false);
      }
    };
    fetchPlans();
  }, [appId, publicKey, apiHost]);
  const handlePlanChange = async (planId) => {
    if (!userId || !appId || !apiHost || !publicKey) {
      setError("Unable to change plan. Please try again.");
      return;
    }
    setIsProcessing(true);
    setError(null);
    try {
      const response = await fetch(`${apiHost}/api/public/subscriptions/change-plan`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": publicKey
        },
        body: JSON.stringify({
          externalId: userId,
          newPlanId: planId,
          immediate: true
          // Apply change immediately
        })
      });
      const data = await response.json();
      console.log("\u{1F4E5} Change plan response:", data);
      if (data.requiresCheckout) {
        console.log("\u{1F4B3} Checkout required, redirecting to payment...");
        if (createCheckout) {
          const session = await createCheckout({
            planId,
            userId,
            successUrl: `${window.location.origin}/checkout/success`,
            cancelUrl: `${window.location.origin}/pricing`
          });
          if (session.url) {
            window.location.href = session.url;
          } else {
            throw new Error("Failed to create checkout session");
          }
        } else {
          throw new Error("Please add a payment method to change your plan");
        }
        return;
      }
      if (!response.ok || !data.success) {
        const errorMsg = data.details || data.error || "Failed to change plan";
        console.error("\u274C Change plan failed:", errorMsg);
        throw new Error(errorMsg);
      }
      const updatedData = await getSubscription?.();
      if (updatedData) {
        setSubscription(updatedData.subscription);
      }
      onPlanChangeComplete?.(planId);
      setSuccessMessage("Plan changed successfully!");
      setShowPlanSelector(false);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Failed to change plan";
      setError(errorMessage);
      onError?.(err instanceof Error ? err : new Error(errorMessage));
    } finally {
      setIsProcessing(false);
    }
  };
  const handleCancel = async () => {
    if (!cancelSubscription || !userId) {
      setError("Cancel functionality not available");
      return;
    }
    setIsProcessing(true);
    setError(null);
    setSuccessMessage(null);
    try {
      await cancelSubscription({
        userId,
        immediate: true,
        cancelAtPeriodEnd: false
      });
      setSuccessMessage("Your subscription has been canceled successfully.");
      setShowCancelConfirm(false);
      onCancelComplete?.();
      setTimeout(() => window.location.reload(), 2e3);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Failed to cancel subscription";
      setError(errorMessage);
      onError?.(err instanceof Error ? err : new Error(errorMessage));
    } finally {
      setIsProcessing(false);
    }
  };
  const handlePause = async () => {
    if (!pauseSubscription || !userId) {
      setError("Pause functionality not available");
      return;
    }
    setIsProcessing(true);
    setError(null);
    try {
      const pauseUntil = /* @__PURE__ */ new Date();
      pauseUntil.setMonth(pauseUntil.getMonth() + 1);
      await pauseSubscription({ userId, behavior: "void" });
      setSuccessMessage("Subscription paused for 1 month");
      setTimeout(() => window.location.reload(), 2e3);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Failed to pause subscription";
      setError(errorMessage);
      onError?.(err instanceof Error ? err : new Error(errorMessage));
    } finally {
      setIsProcessing(false);
    }
  };
  const handleResume = async () => {
    if (!resumeSubscription || !userId) {
      setError("Resume functionality not available");
      return;
    }
    setIsProcessing(true);
    setError(null);
    try {
      await resumeSubscription(userId);
      setSuccessMessage("Subscription resumed successfully");
      setTimeout(() => window.location.reload(), 2e3);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Failed to resume subscription";
      setError(errorMessage);
      onError?.(err instanceof Error ? err : new Error(errorMessage));
    } finally {
      setIsProcessing(false);
    }
  };
  const isDark = theme === "dark";
  const baseClasses = isDark ? "bg-gray-900 text-white" : "bg-white text-gray-900";
  const borderClass = isDark ? "border-gray-700" : "border-gray-200";
  const getPricingDisplay = (pricing) => {
    if (!pricing || typeof pricing !== "object") {
      return { amount: "Free", interval: "" };
    }
    const pricingConfig = pricing;
    const currency = pricingConfig.currency || "USD";
    const currencySymbol = currency === "USD" ? "$" : currency;
    if (pricingConfig.model === "free") {
      return { amount: "Free", interval: "" };
    }
    if (pricingConfig.model === "usage" || pricingConfig.model === "usage_based") {
      const basePrice = pricingConfig.usage?.tiers?.[0]?.price || pricingConfig.baseFee || 0;
      return {
        amount: basePrice === 0 ? "Free" : `Starting at ${currencySymbol}${basePrice}`,
        interval: basePrice === 0 ? "" : `/${pricingConfig.usage?.unit || "unit"}`
      };
    }
    const amount = pricingConfig.amount ?? pricingConfig.baseFee ?? pricingConfig.price ?? 0;
    if (amount === 0) {
      return { amount: "Free", interval: "" };
    }
    const interval = pricingConfig.interval || pricingConfig.billingCycle || "month";
    return {
      amount: `${currencySymbol}${amount}`,
      interval: `/${interval}`
    };
  };
  if (contextLoading || isLoadingPlans) {
    return /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("div", { className, style: {
      padding: "32px",
      borderRadius: "16px",
      background: isDark ? "#1f2937" : "#ffffff",
      color: isDark ? "#ffffff" : "#111827",
      border: `1px solid ${isDark ? "#374151" : "#e5e7eb"}`,
      boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
      maxWidth: "800px",
      margin: "0 auto"
    }, children: /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { style: { display: "flex", flexDirection: "column", gap: "20px" }, children: [
      /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("div", { style: { height: "32px", background: isDark ? "#374151" : "#e5e7eb", borderRadius: "8px", width: "60%", animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite" } }),
      /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("div", { style: { height: "20px", background: isDark ? "#374151" : "#e5e7eb", borderRadius: "6px", width: "40%", animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite" } }),
      /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("div", { style: { height: "20px", background: isDark ? "#374151" : "#e5e7eb", borderRadius: "6px", width: "50%", animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite" } }),
      /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("div", { style: { height: "48px", background: isDark ? "#374151" : "#e5e7eb", borderRadius: "8px", width: "100%", marginTop: "8px", animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite" } })
    ] }) });
  }
  if (!subscription) {
    return /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { className, style: {
      padding: "32px",
      borderRadius: "16px",
      background: isDark ? "#1f2937" : "#ffffff",
      color: isDark ? "#ffffff" : "#111827",
      border: `1px solid ${isDark ? "#374151" : "#e5e7eb"}`,
      boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
      maxWidth: "800px",
      margin: "0 auto",
      textAlign: "center"
    }, children: [
      /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("div", { style: {
        width: "64px",
        height: "64px",
        borderRadius: "50%",
        background: isDark ? "#374151" : "#f3f4f6",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto 24px",
        fontSize: "28px"
      }, children: "\u{1F4CB}" }),
      /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("h3", { style: { fontSize: "24px", fontWeight: 700, marginBottom: "12px", color: isDark ? "#ffffff" : "#111827" }, children: "No Active Subscription" }),
      /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("p", { style: { fontSize: "16px", marginBottom: "24px", color: isDark ? "#9ca3af" : "#6b7280", maxWidth: "400px", margin: "0 auto 32px" }, children: "You don't have an active subscription yet. Choose a plan to get started." }),
      /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
        "button",
        {
          onClick: () => setShowPlanSelector(true),
          style: {
            padding: "14px 32px",
            background: "#2563eb",
            color: "#ffffff",
            borderRadius: "10px",
            border: "none",
            fontWeight: 600,
            fontSize: "16px",
            cursor: "pointer",
            transition: "all 0.2s",
            boxShadow: "0 4px 6px -1px rgba(37, 99, 235, 0.3)"
          },
          onMouseOver: (e) => e.currentTarget.style.transform = "translateY(-2px)",
          onMouseOut: (e) => e.currentTarget.style.transform = "translateY(0)",
          children: "View Plans"
        }
      )
    ] });
  }
  const statusColors = {
    active: "bg-green-100 text-green-800 border-green-200",
    trialing: "bg-blue-100 text-blue-800 border-blue-200",
    canceled: "bg-red-100 text-red-800 border-red-200",
    paused: "bg-yellow-100 text-yellow-800 border-yellow-200"
  };
  const statusColor = statusColors[subscription.status] || "bg-gray-100 text-gray-800 border-gray-200";
  return /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { className, style: {
    padding: "32px",
    borderRadius: "16px",
    background: isDark ? "#1f2937" : "#ffffff",
    color: isDark ? "#ffffff" : "#111827",
    border: `1px solid ${isDark ? "#374151" : "#e5e7eb"}`,
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    maxWidth: "800px",
    margin: "0 auto"
  }, children: [
    /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { style: { marginBottom: "32px" }, children: [
      /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("h2", { style: { fontSize: "28px", fontWeight: 700, marginBottom: "16px", color: isDark ? "#ffffff" : "#111827", letterSpacing: "-0.025em" }, children: "Your Subscription" }),
      successMessage && /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { style: {
        background: "#d1fae5",
        border: "1px solid #a7f3d0",
        color: "#065f46",
        padding: "14px 18px",
        borderRadius: "10px",
        marginBottom: "16px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        fontSize: "15px",
        fontWeight: 500
      }, children: [
        /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("span", { style: { fontSize: "20px" }, children: "\u2713" }),
        successMessage
      ] }),
      error && /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { style: {
        background: "#fee2e2",
        border: "1px solid #fecaca",
        color: "#991b1b",
        padding: "14px 18px",
        borderRadius: "10px",
        marginBottom: "16px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        fontSize: "15px",
        fontWeight: 500
      }, children: [
        /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("span", { style: { fontSize: "20px" }, children: "\u26A0" }),
        error
      ] })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { style: {
      marginBottom: "28px",
      padding: "28px",
      border: `2px solid ${isDark ? "#374151" : "#e5e7eb"}`,
      borderRadius: "12px",
      background: isDark ? "rgba(31, 41, 55, 0.5)" : "rgba(249, 250, 251, 0.5)"
    }, children: [
      /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "20px" }, children: [
        /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { children: [
          /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("h3", { style: { fontSize: "24px", fontWeight: 700, color: isDark ? "#ffffff" : "#111827", marginBottom: "8px" }, children: subscription.planName || "Current Plan" }),
          /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("p", { style: { fontSize: "14px", color: isDark ? "#9ca3af" : "#6b7280", fontFamily: "monospace" }, children: subscription.planId })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("span", { style: {
          padding: "6px 16px",
          borderRadius: "100px",
          fontSize: "13px",
          fontWeight: 700,
          textTransform: "uppercase",
          letterSpacing: "0.05em",
          border: "2px solid",
          background: subscription.status === "active" ? "#d1fae5" : subscription.status === "trialing" ? "#dbeafe" : subscription.status === "canceled" ? "#fee2e2" : "#fef3c7",
          color: subscription.status === "active" ? "#065f46" : subscription.status === "trialing" ? "#1e40af" : subscription.status === "canceled" ? "#991b1b" : "#92400e",
          borderColor: subscription.status === "active" ? "#10b981" : subscription.status === "trialing" ? "#3b82f6" : subscription.status === "canceled" ? "#ef4444" : "#f59e0b"
        }, children: subscription.status || "Active" })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { style: { display: "flex", flexDirection: "column", gap: "12px", fontSize: "15px" }, children: [
        subscription.currentPeriodEnd && /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { style: {
          display: "flex",
          alignItems: "center",
          gap: "10px",
          padding: "12px 16px",
          background: isDark ? "#374151" : "#f9fafb",
          borderRadius: "8px"
        }, children: [
          /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("span", { style: { fontSize: "18px" }, children: "\u{1F4C5}" }),
          /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { children: [
            /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("span", { style: { fontWeight: 600, color: isDark ? "#ffffff" : "#111827" }, children: subscription.status === "canceled" ? "Access until" : "Renews on" }),
            /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("span", { style: { marginLeft: "8px", color: isDark ? "#9ca3af" : "#6b7280" }, children: new Date(subscription.currentPeriodEnd).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric"
            }) })
          ] })
        ] }),
        subscription.trialEnd && subscription.status === "trialing" && /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { style: {
          display: "flex",
          alignItems: "center",
          gap: "10px",
          padding: "12px 16px",
          background: "#dbeafe",
          borderRadius: "8px",
          border: "1px solid #93c5fd"
        }, children: [
          /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("span", { style: { fontSize: "18px" }, children: "\u{1F381}" }),
          /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { children: [
            /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("span", { style: { fontWeight: 600, color: "#1e40af" }, children: "Trial ends" }),
            /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("span", { style: { marginLeft: "8px", color: "#1e40af" }, children: new Date(subscription.trialEnd).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric"
            }) })
          ] })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { style: { display: "flex", flexDirection: "column", gap: "14px" }, children: [
      subscription.status === "active" && /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)(import_jsx_runtime13.Fragment, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
          "button",
          {
            onClick: () => setShowPlanSelector(true),
            disabled: isProcessing,
            style: {
              width: "100%",
              padding: "14px 20px",
              background: "#2563eb",
              color: "#ffffff",
              borderRadius: "10px",
              border: "none",
              fontWeight: 600,
              fontSize: "16px",
              cursor: isProcessing ? "not-allowed" : "pointer",
              opacity: isProcessing ? 0.5 : 1,
              transition: "all 0.2s",
              boxShadow: "0 4px 6px -1px rgba(37, 99, 235, 0.3)"
            },
            onMouseOver: (e) => !isProcessing && (e.currentTarget.style.transform = "translateY(-2px)"),
            onMouseOut: (e) => e.currentTarget.style.transform = "translateY(0)",
            children: "Change Plan"
          }
        ),
        pauseSubscription && /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
          "button",
          {
            onClick: handlePause,
            disabled: isProcessing,
            style: {
              width: "100%",
              padding: "14px 20px",
              background: isDark ? "#374151" : "#ffffff",
              color: isDark ? "#ffffff" : "#111827",
              border: `2px solid ${isDark ? "#4b5563" : "#d1d5db"}`,
              borderRadius: "10px",
              fontWeight: 600,
              fontSize: "16px",
              cursor: isProcessing ? "not-allowed" : "pointer",
              opacity: isProcessing ? 0.5 : 1,
              transition: "all 0.2s"
            },
            onMouseOver: (e) => !isProcessing && (e.currentTarget.style.borderColor = isDark ? "#6b7280" : "#9ca3af"),
            onMouseOut: (e) => e.currentTarget.style.borderColor = isDark ? "#4b5563" : "#d1d5db",
            children: isProcessing ? "Processing..." : "Pause Subscription"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
          "button",
          {
            onClick: () => setShowCancelConfirm(true),
            disabled: isProcessing,
            style: {
              width: "100%",
              padding: "14px 20px",
              background: "transparent",
              color: "#dc2626",
              border: "2px solid #dc2626",
              borderRadius: "10px",
              fontWeight: 600,
              fontSize: "16px",
              cursor: isProcessing ? "not-allowed" : "pointer",
              opacity: isProcessing ? 0.5 : 1,
              transition: "all 0.2s"
            },
            onMouseOver: (e) => !isProcessing && (e.currentTarget.style.background = "#fef2f2"),
            onMouseOut: (e) => e.currentTarget.style.background = "transparent",
            children: "Cancel Subscription"
          }
        )
      ] }),
      subscription.status === "trialing" && /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)(import_jsx_runtime13.Fragment, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
          "button",
          {
            onClick: () => setShowPlanSelector(true),
            disabled: isProcessing,
            style: {
              width: "100%",
              padding: "14px 20px",
              background: "#2563eb",
              color: "#ffffff",
              borderRadius: "10px",
              border: "none",
              fontWeight: 600,
              fontSize: "16px",
              cursor: isProcessing ? "not-allowed" : "pointer",
              opacity: isProcessing ? 0.5 : 1,
              transition: "all 0.2s",
              boxShadow: "0 4px 6px -1px rgba(37, 99, 235, 0.3)"
            },
            onMouseOver: (e) => !isProcessing && (e.currentTarget.style.transform = "translateY(-2px)"),
            onMouseOut: (e) => e.currentTarget.style.transform = "translateY(0)",
            children: "Change Plan"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
          "button",
          {
            onClick: () => setShowCancelConfirm(true),
            disabled: isProcessing,
            style: {
              width: "100%",
              padding: "14px 20px",
              background: "transparent",
              color: "#dc2626",
              border: "2px solid #dc2626",
              borderRadius: "10px",
              fontWeight: 600,
              fontSize: "16px",
              cursor: isProcessing ? "not-allowed" : "pointer",
              opacity: isProcessing ? 0.5 : 1,
              transition: "all 0.2s"
            },
            onMouseOver: (e) => !isProcessing && (e.currentTarget.style.background = "#fef2f2"),
            onMouseOut: (e) => e.currentTarget.style.background = "transparent",
            children: "Cancel Trial"
          }
        )
      ] }),
      subscription.status === "paused" && resumeSubscription && /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
        "button",
        {
          onClick: handleResume,
          disabled: isProcessing,
          style: {
            width: "100%",
            padding: "14px 20px",
            background: "#16a34a",
            color: "#ffffff",
            borderRadius: "10px",
            border: "none",
            fontWeight: 600,
            fontSize: "16px",
            cursor: isProcessing ? "not-allowed" : "pointer",
            opacity: isProcessing ? 0.5 : 1,
            transition: "all 0.2s",
            boxShadow: "0 4px 6px -1px rgba(22, 163, 74, 0.3)"
          },
          onMouseOver: (e) => !isProcessing && (e.currentTarget.style.transform = "translateY(-2px)"),
          onMouseOut: (e) => e.currentTarget.style.transform = "translateY(0)",
          children: isProcessing ? "Resuming..." : "Resume Subscription"
        }
      ),
      subscription.status === "canceled" && /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
        "button",
        {
          onClick: () => setShowPlanSelector(true),
          style: {
            width: "100%",
            padding: "14px 20px",
            background: "#2563eb",
            color: "#ffffff",
            borderRadius: "10px",
            border: "none",
            fontWeight: 600,
            fontSize: "16px",
            cursor: "pointer",
            transition: "all 0.2s",
            boxShadow: "0 4px 6px -1px rgba(37, 99, 235, 0.3)"
          },
          onMouseOver: (e) => e.currentTarget.style.transform = "translateY(-2px)",
          onMouseOut: (e) => e.currentTarget.style.transform = "translateY(0)",
          children: "Resubscribe"
        }
      )
    ] }),
    showPlanSelector && /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("div", { style: {
      position: "fixed",
      inset: 0,
      background: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
      padding: "16px"
    }, children: /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("div", { style: {
      background: isDark ? "#1f2937" : "#ffffff",
      borderRadius: "16px",
      boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
      maxWidth: "900px",
      width: "100%",
      maxHeight: "90vh",
      overflowY: "auto"
    }, children: /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { style: { padding: "32px" }, children: [
      /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("h3", { style: { fontSize: "28px", fontWeight: 700, marginBottom: "24px", color: isDark ? "#ffffff" : "#111827" }, children: "Choose a Plan" }),
      isProcessing && /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { style: {
        marginBottom: "20px",
        padding: "16px 20px",
        background: "#dbeafe",
        border: "1px solid #93c5fd",
        color: "#1e40af",
        borderRadius: "10px",
        display: "flex",
        alignItems: "center",
        gap: "12px",
        fontSize: "15px",
        fontWeight: 500
      }, children: [
        /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("div", { style: {
          width: "20px",
          height: "20px",
          border: "2px solid #3b82f6",
          borderTopColor: "transparent",
          borderRadius: "50%",
          animation: "spin 1s linear infinite"
        } }),
        /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("span", { children: "Processing plan change..." })
      ] }),
      plans.length === 0 ? /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("p", { style: { color: isDark ? "#9ca3af" : "#6b7280", fontSize: "16px" }, children: "No plans available" }) : /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("div", { style: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
        gap: "16px",
        marginBottom: "24px"
      }, children: plans.map((plan) => {
        const isCurrentPlan = plan.id === subscription.planId;
        const pricing = getPricingDisplay(plan.pricing);
        return /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)(
          "div",
          {
            onClick: () => !isCurrentPlan && !isProcessing && handlePlanChange(plan.id),
            style: {
              border: `2px solid ${isCurrentPlan ? "#2563eb" : isDark ? "#374151" : "#e5e7eb"}`,
              borderRadius: "12px",
              padding: "24px",
              cursor: isProcessing ? "not-allowed" : isCurrentPlan ? "default" : "pointer",
              opacity: isProcessing ? 0.5 : 1,
              background: isCurrentPlan ? isDark ? "rgba(37, 99, 235, 0.1)" : "#eff6ff" : isDark ? "#1f2937" : "#ffffff",
              transition: "all 0.2s"
            },
            onMouseOver: (e) => !isCurrentPlan && !isProcessing && (e.currentTarget.style.borderColor = "#3b82f6"),
            onMouseOut: (e) => !isCurrentPlan && (e.currentTarget.style.borderColor = isDark ? "#374151" : "#e5e7eb"),
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { style: { marginBottom: "16px" }, children: [
                /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("h4", { style: { fontSize: "20px", fontWeight: 700, marginBottom: "4px", color: isDark ? "#ffffff" : "#111827" }, children: plan.name }),
                /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { style: { display: "flex", alignItems: "baseline", gap: "4px" }, children: [
                  /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("span", { style: { fontSize: "32px", fontWeight: 700, color: isDark ? "#ffffff" : "#111827" }, children: pricing.amount }),
                  pricing.interval && /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("span", { style: { fontSize: "16px", color: isDark ? "#9ca3af" : "#6b7280" }, children: pricing.interval })
                ] })
              ] }),
              plan.description && /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("p", { style: { fontSize: "14px", marginBottom: "12px", color: isDark ? "#9ca3af" : "#6b7280", lineHeight: "1.5" }, children: plan.description }),
              isCurrentPlan && /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("span", { style: {
                display: "inline-block",
                fontSize: "14px",
                color: "#2563eb",
                fontWeight: 600
              }, children: "\u2713 Current Plan" })
            ]
          },
          plan.id
        );
      }) }),
      /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
        "button",
        {
          onClick: () => setShowPlanSelector(false),
          disabled: isProcessing,
          style: {
            width: "100%",
            padding: "14px 20px",
            background: isDark ? "#374151" : "#ffffff",
            color: isDark ? "#ffffff" : "#111827",
            border: `2px solid ${isDark ? "#4b5563" : "#d1d5db"}`,
            borderRadius: "10px",
            fontWeight: 600,
            fontSize: "16px",
            cursor: isProcessing ? "not-allowed" : "pointer",
            opacity: isProcessing ? 0.5 : 1,
            transition: "all 0.2s"
          },
          onMouseOver: (e) => !isProcessing && (e.currentTarget.style.background = isDark ? "#4b5563" : "#f3f4f6"),
          onMouseOut: (e) => e.currentTarget.style.background = isDark ? "#374151" : "#ffffff",
          children: "Close"
        }
      )
    ] }) }) }),
    showCancelConfirm && /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("div", { style: {
      position: "fixed",
      inset: 0,
      background: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
      padding: "16px"
    }, children: /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("div", { style: {
      background: isDark ? "#1f2937" : "#ffffff",
      borderRadius: "16px",
      boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
      maxWidth: "500px",
      width: "100%"
    }, children: /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { style: { padding: "32px" }, children: [
      /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("div", { style: {
        width: "64px",
        height: "64px",
        borderRadius: "50%",
        background: "#fee2e2",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto 24px",
        fontSize: "32px"
      }, children: "\u26A0\uFE0F" }),
      /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("h3", { style: { fontSize: "24px", fontWeight: 700, marginBottom: "16px", color: isDark ? "#ffffff" : "#111827", textAlign: "center" }, children: "Cancel Subscription?" }),
      /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("p", { style: {
        fontSize: "16px",
        marginBottom: "32px",
        color: isDark ? "#d1d5db" : "#4b5563",
        textAlign: "center",
        lineHeight: "1.6"
      }, children: "Your subscription will be canceled immediately and you'll lose access right away. This action cannot be undone." }),
      /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { style: { display: "flex", gap: "12px" }, children: [
        /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
          "button",
          {
            onClick: handleCancel,
            disabled: isProcessing,
            style: {
              flex: 1,
              padding: "14px 20px",
              background: "#dc2626",
              color: "#ffffff",
              borderRadius: "10px",
              border: "none",
              fontWeight: 600,
              fontSize: "16px",
              cursor: isProcessing ? "not-allowed" : "pointer",
              opacity: isProcessing ? 0.5 : 1,
              transition: "all 0.2s"
            },
            onMouseOver: (e) => !isProcessing && (e.currentTarget.style.background = "#b91c1c"),
            onMouseOut: (e) => e.currentTarget.style.background = "#dc2626",
            children: isProcessing ? "Canceling..." : "Yes, Cancel Now"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
          "button",
          {
            onClick: () => setShowCancelConfirm(false),
            disabled: isProcessing,
            style: {
              flex: 1,
              padding: "14px 20px",
              background: isDark ? "#374151" : "#ffffff",
              color: isDark ? "#ffffff" : "#111827",
              border: `2px solid ${isDark ? "#4b5563" : "#d1d5db"}`,
              borderRadius: "10px",
              fontWeight: 600,
              fontSize: "16px",
              cursor: isProcessing ? "not-allowed" : "pointer",
              transition: "all 0.2s"
            },
            onMouseOver: (e) => !isProcessing && (e.currentTarget.style.background = isDark ? "#4b5563" : "#f3f4f6"),
            onMouseOut: (e) => e.currentTarget.style.background = isDark ? "#374151" : "#ffffff",
            children: "Keep It"
          }
        )
      ] })
    ] }) }) })
  ] });
}

// src/components/subscription-manager/hooks/useSubscription.ts
var import_react17 = require("react");
init_UseCeloProvider();

// src/components/subscription-manager/hooks/usePaymentMethods.ts
var import_react18 = require("react");
init_UseCeloProvider();

// src/components/subscription-manager/hooks/useBillingHistory.ts
var import_react19 = require("react");
init_UseCeloProvider();

// src/index.ts
init_payment_client();

// src/api/client.ts
init_types();
var MemoryCache = class {
  constructor() {
    this.cache = /* @__PURE__ */ new Map();
  }
  get(key) {
    const entry = this.cache.get(key);
    if (!entry) return null;
    if (Date.now() > entry.expiry) {
      this.cache.delete(key);
      return null;
    }
    return entry.data;
  }
  set(key, data, ttl = 3e5) {
    this.cache.set(key, {
      data,
      timestamp: Date.now(),
      expiry: Date.now() + ttl
    });
  }
  delete(key) {
    return this.cache.delete(key);
  }
  clear() {
    this.cache.clear();
  }
  isValid(key) {
    const entry = this.cache.get(key);
    if (!entry) return false;
    return Date.now() <= entry.expiry;
  }
};
var UseCeloApiClient = class {
  constructor(config) {
    this.authToken = null;
    this.config = {
      apiHost: "https://usecelo.com",
      enableCache: true,
      cacheTTL: 3e5,
      // 5 minutes
      ...config
    };
    this.cache = new MemoryCache();
  }
  // Update configuration
  updateConfig(config) {
    this.config = { ...this.config, ...config };
    if (config.userId) {
      this.cache.clear();
      this.authToken = null;
    }
  }
  // Set authentication token
  setAuthToken(token) {
    this.authToken = token;
  }
  // Generic API request method
  async request(endpoint, options = {}, useCache = true, cacheTTL) {
    const cacheKey = `${endpoint}-${JSON.stringify(options.body || {})}`;
    if (useCache && this.config.enableCache && options.method !== "POST") {
      const cached = this.cache.get(cacheKey);
      if (cached) return Promise.resolve(cached);
    }
    const url = `${this.config.apiHost}${endpoint}`;
    const headers = {
      "Content-Type": "application/json",
      "x-api-key": this.config.apiKey || "",
      ...options.headers || {}
    };
    if (this.authToken) {
      headers.Authorization = `Bearer ${this.authToken}`;
    }
    try {
      const response = await fetch(url, {
        ...options,
        headers
      });
      if (!response.ok) {
        if (response.status === 401) {
          this.authToken = null;
          throw new AuthError("Invalid API key or authentication token");
        }
        const errorData = await response.json().catch(() => ({}));
        throw new ApiError(
          errorData.error || `HTTP ${response.status}`,
          response.status.toString(),
          errorData
        );
      }
      const data = await response.json();
      if (!data.success) {
        throw new ApiError(data.error || "API request failed", "400", 400);
      }
      const result = data.data;
      if (useCache && this.config.enableCache && options.method !== "POST") {
        this.cache.set(cacheKey, result, cacheTTL || this.config.cacheTTL);
      }
      return result;
    } catch (error) {
      if (error instanceof ApiError || error instanceof AuthError) {
        throw error;
      }
      throw new NetworkError(`Request failed: ${error instanceof Error ? error.message : "Unknown error"}`);
    }
  }
  // User Management APIs
  async identify(userData) {
    const response = await this.request(
      "/api/public/users/identify",
      {
        method: "POST",
        body: JSON.stringify(userData)
      },
      false
      // Don't cache identify requests
    );
    return response;
  }
  async syncUser(userData) {
    return this.request(
      "/api/public/users/sync",
      {
        method: "POST",
        body: JSON.stringify(userData)
      },
      false
    );
  }
  async getUserDetails(externalId) {
    return this.request(
      `/api/public/users/sync?externalId=${encodeURIComponent(externalId)}`,
      {},
      true,
      6e4
      // Cache for 1 minute
    );
  }
  // Feature Access APIs
  async checkFeature(featureName, userId) {
    const userParam = userId || this.config.userId;
    if (!userParam) {
      throw new AuthError("User ID is required for feature checking");
    }
    return this.request(
      `/api/public/entitlements/${this.config.appId}?userId=${encodeURIComponent(userParam)}&featureName=${encodeURIComponent(featureName)}`,
      {},
      true,
      3e4
      // Cache for 30 seconds
    );
  }
  async getFeatures(planId) {
    const endpoint = planId ? `/api/public/features/${this.config.appId}?planId=${planId}` : `/api/public/features/${this.config.appId}`;
    return this.request(endpoint, {}, true, this.config.cacheTTL);
  }
  // Usage Tracking APIs
  async trackUsage(unitType, amount = 1, userId) {
    const userParam = userId || this.config.userId;
    if (!userParam) {
      throw new AuthError("User ID is required for usage tracking");
    }
    await this.request(
      "/api/public/usage/increment",
      {
        method: "POST",
        body: JSON.stringify({
          userId: userParam,
          unitType,
          amount
        })
      },
      false
      // Never cache usage tracking
    );
    this.cache.delete(`/api/public/entitlements/${this.config.appId}?userId=${encodeURIComponent(userParam)}&featureName=${unitType}`);
    this.cache.delete(`/api/public/subscriptions/current?externalId=${encodeURIComponent(userParam)}`);
  }
  // Subscription APIs
  async getCurrentSubscription(externalId) {
    const userParam = externalId || this.config.userId;
    if (!userParam) {
      throw new AuthError("User ID is required for subscription data");
    }
    return this.request(
      `/api/public/subscriptions/current?externalId=${encodeURIComponent(userParam)}`,
      {},
      true,
      6e4
      // Cache for 1 minute
    );
  }
  async changePlan(newPlanId, immediate = false, externalId) {
    const userParam = externalId || this.config.userId;
    if (!userParam) {
      throw new AuthError("User ID is required for plan changes");
    }
    const response = await this.request(
      "/api/public/subscriptions/change-plan",
      {
        method: "POST",
        body: JSON.stringify({
          externalId: userParam,
          newPlanId,
          immediate
        })
      },
      false
    );
    this.cache.delete(`/api/public/subscriptions/current?externalId=${encodeURIComponent(userParam)}`);
    return response;
  }
  async cancelSubscription(immediate = false, reason, feedback, externalId) {
    const userParam = externalId || this.config.userId;
    if (!userParam) {
      throw new AuthError("User ID is required for subscription cancellation");
    }
    const response = await this.request(
      "/api/public/subscriptions/cancel",
      {
        method: "POST",
        body: JSON.stringify({
          externalId: userParam,
          immediate,
          reason,
          feedback
        })
      },
      false
    );
    this.cache.delete(`/api/public/subscriptions/current?externalId=${encodeURIComponent(userParam)}`);
    return response;
  }
  // Plan APIs
  async getPlans() {
    const response = await this.request(
      `/api/public/plans/${this.config.appId}`,
      {},
      true,
      this.config.cacheTTL
    );
    return response;
  }
  async getPlan(planId) {
    return this.request(
      `/api/public/plans/${this.config.appId}/${planId}`,
      {},
      true,
      this.config.cacheTTL
    );
  }
  // Trial APIs
  async startTrial(planId, userId) {
    const userParam = userId || this.config.userId;
    if (!userParam) {
      throw new AuthError("User ID is required to start trial");
    }
    const response = await this.request(
      "/api/public/trials/start",
      {
        method: "POST",
        body: JSON.stringify({
          planId,
          userId: userParam
        })
      },
      false
    );
    this.cache.delete(`/api/public/subscriptions/current?externalId=${encodeURIComponent(userParam)}`);
    return response;
  }
  // Cache Management
  clearCache() {
    this.cache.clear();
  }
  invalidateCache(pattern) {
    if (pattern) {
      this.cache.clear();
    } else {
      this.cache.clear();
    }
  }
  // Health check
  async healthCheck() {
    try {
      await this.request("/api/public/health", { method: "GET" }, false);
      return true;
    } catch {
      return false;
    }
  }
};

// src/index.ts
var VERSION = "0.6.0";
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  CheckoutButton,
  CheckoutCancel,
  CheckoutSuccess,
  Feature,
  FeatureGate,
  MultiFeatures,
  MultiUsageDisplay,
  PaymentGatewayClient,
  PlanTier,
  PricingTable,
  SimplifiedSubscriptionManager,
  SubscriptionGate,
  SubscriptionManager,
  TrialOnly,
  UpgradePrompt,
  UsageControl,
  UsageDisplay,
  UsageTracker,
  UseCeloApiClient,
  UseCeloProvider,
  UserIdProvider,
  VERSION,
  useCheckout,
  useCheckoutButton,
  useCheckoutCancel,
  useCheckoutFlow,
  useCheckoutSuccess,
  useFeature,
  usePricing,
  usePricingFeature,
  usePricingSubscription,
  usePricingTableConfig,
  useSubscriptionManagement,
  useUsage,
  useUsageStats,
  useUseCelo,
  withFeatureGate
});
